(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jttp-about"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const init = (root) => {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = '1';
      root.classList.add('has-js');
      requestAnimationFrame(() => root.classList.add('is-ready'));
      const $ = (s) => root.querySelector(s);
      const $$ = (s) => [...root.querySelectorAll(s)];

      /* quote: split into words for the reveal */
      const q = $('[data-words]');
      if (q && !reduce) {
        let i = 0;
        const walk = (node) => [...node.childNodes].forEach((n) => {
          if (n.nodeType === 3) {
            const frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach((w) => {
              if (!w) return;
              if (/^\s+$/.test(w)) { frag.append(w); return; }
              const s = document.createElement('span'); s.className = 'w'; s.style.setProperty('--i', i++); s.textContent = w; frag.append(s);
            });
            n.replaceWith(frag);
          } else if (n.nodeType === 1) walk(n);
        });
        walk(q);
      }

      /* reveal + count-up */
      const countUp = (el) => {
        const raw = el.dataset.count || el.textContent;
        const m = raw.match(/^(\D*)([\d,]+)(.*)$/);
        if (!m || reduce) return;
        const target = +m[2].replace(/,/g, ''), comma = m[2].includes(',');
        // years and small labels stay as they are
        if (target >= 1900 && target <= 2100 && !comma) return;
        const t0 = performance.now();
        const step = (now) => {
          const k = Math.min(1, (now - t0) / 1400), v = Math.round(target * (1 - Math.pow(1 - k, 3)));
          el.textContent = m[1] + (comma ? v.toLocaleString('en-US') : v) + m[3];
          if (k < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      };
      const io = 'IntersectionObserver' in window && !reduce ? new IntersectionObserver((es) => es.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        e.target.querySelectorAll('[data-count]').forEach(countUp);
        io.unobserve(e.target);
      }), { rootMargin: '0px 0px -10% 0px' }) : null;
      [...$$('.ab-reveal'), ...(q ? [q] : [])].forEach((el) => (io ? io.observe(el) : el.classList.add('is-in')));

      /* hero parallax + timeline line drawing */
      const hero = $('[data-hero]'), media = $('[data-hero-media]'), copy = $('[data-hero-copy]');
      const tl = $('[data-timeline]'), line = $('[data-line]');
      if (!reduce) {
        let tk = false;
        const run = () => {
          tk = false;
          if (hero) {
            const r = hero.getBoundingClientRect();
            if (r.bottom > 0) {
              const p = Math.min(1, Math.max(0, -r.top / r.height));
              media.style.transform = `translate3d(0, ${p * 20}%, 0) scale(${1 + p * .06})`;
              copy.style.transform = `translate3d(0, ${p * 70}px, 0)`; copy.style.opacity = String(1 - p * 1.3);
            }
          }
          if (tl && line) {
            const r = tl.getBoundingClientRect();
            const p = Math.min(1, Math.max(0, (innerHeight * .7 - r.top) / r.height));
            line.style.setProperty('--p', p.toFixed(3));
          }
        };
        addEventListener('scroll', () => { if (!tk) { tk = true; requestAnimationFrame(run); } }, { passive: true });
        setTimeout(() => { if (media) media.style.transition = 'none'; run(); }, 2500);
        run();
      }
    };
    const boot = () => document.querySelectorAll('.jttp-ab').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('.jttp-ab')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jttp-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const EASE = 'cubic-bezier(.2,.7,.2,1)';

    /* ---------- cart (theme drawer, same as the product page) ---------- */
    const addToCart = async (id, trigger) => {
      let Cart = null;
      try { ({ Cart } = await import('@troop-themes/main')); } catch {}
      const root = window.Shopify?.routes?.root || '/';
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: Cart?.sections || [] }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
      if (!Cart) { location.href = `${root}cart`; return; }
      window.addEventListener('theme:cart:updated', () => requestAnimationFrame(() => window.dispatchEvent(new CustomEvent('theme:cart:open', { detail: trigger }))), { once: true });
      Cart.fetchBasket?.().then(() => Cart.updateTotals([...Cart.basket.values()].reduce((a, b) => a + b, 0))).catch(() => {});
      if (data.sections && Object.keys(data.sections).length) Cart.updateAllHtml(data.sections, true);
      else window.dispatchEvent(new CustomEvent('theme:cart:open', { detail: trigger }));
    };

    const init = (root) => {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = '1';
      root.classList.add('has-js');
      const $ = (s, el = root) => el.querySelector(s);
      const $$ = (s, el = root) => [...el.querySelectorAll(s)];
      const t = (k) => root.dataset[k] || '';
      const money = (c) => { try { return new Intl.NumberFormat(root.dataset.locale, { style: 'currency', currency: root.dataset.currency, maximumFractionDigits: c % 100 ? 2 : 0 }).format(c / 100); } catch { return '$' + Math.round(c / 100); } };
      const toast = (msg) => {
        const el = $('[data-toast]');
        el.textContent = msg; el.hidden = false;
        el.style.animation = 'none'; el.offsetWidth; el.style.animation = '';
        clearTimeout(el._t); el._t = setTimeout(() => { el.hidden = true; }, 2600);
      };
      requestAnimationFrame(() => root.classList.add('is-ready'));

      /* ---------- hero motion ---------- */
      const hero = $('[data-hero]');
      const heroMedia = $('[data-hero-media]');
      const heroCopy = hero && $('.cl-hero__copy', hero);
      if (hero && !reduce) {
        let ticking = false;
        const onScroll = () => {
          ticking = false;
          const r = hero.getBoundingClientRect();
          if (r.bottom < 0 || r.top > innerHeight) return;
          const p = Math.min(1, Math.max(0, -r.top / r.height));
          if (heroMedia) heroMedia.style.transform = hero.classList.contains('cl-hero--media') ? `translate3d(0, ${p * 22}%, 0) scale(${1 + p * .08})` : `translate3d(0, ${p * -60}px, 0)`;
          if (heroCopy) { heroCopy.style.transform = `translate3d(0, ${p * 80}px, 0)`; heroCopy.style.opacity = String(1 - p * 1.3); }
        };
        addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
        // the CSS entrance zoom finishes first, then scroll takes over the transform
        setTimeout(() => { if (heroMedia) heroMedia.style.transition = 'none'; onScroll(); }, 2500);
      }
      const frames = $$('[data-frames] .cl-frame');
      if (frames.length > 1 && !reduce) {
        let k = 0;
        setInterval(() => { frames[k].classList.remove('is-on'); k = (k + 1) % frames.length; frames[k].classList.add('is-on'); }, 4200);
      }
      const vid = $('.cl-hero__video, [data-hero-media] video');
      const pauseBtn = $('[data-hero-pause]');
      if (vid) {
        vid.muted = true; vid.playsInline = true;
        let userPaused = reduce;
        let inView = true;
        const sync = () => { if (userPaused || !inView || document.hidden) vid.pause(); else vid.play?.().catch(() => {}); };
        if (reduce) pauseBtn?.setAttribute('aria-pressed', 'true');
        sync();
        // keep it playing when it's on screen (browsers pause muted video in hidden tabs), rest it when scrolled away
        new IntersectionObserver(([en]) => { inView = en.isIntersecting; sync(); }).observe(vid);
        document.addEventListener('visibilitychange', sync);
        vid.addEventListener('pause', () => { if (!userPaused && inView && !document.hidden) setTimeout(sync, 300); });
        pauseBtn?.addEventListener('click', () => {
          const paused = !vid.paused;
          userPaused = paused;
          paused ? vid.pause() : vid.play();
          pauseBtn.setAttribute('aria-pressed', String(paused));
          pauseBtn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
        });
      }
      const bar = $('[data-bar]');
      $$('[data-scroll-grid]').forEach((b) => b.addEventListener('click', (e) => { e.preventDefault(); bar.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); }));

      /* sticky bar shadow */
      new IntersectionObserver(([en]) => bar.classList.toggle('is-stuck', !en.isIntersecting && en.boundingClientRect.top < 0), { rootMargin: `-${parseFloat(getComputedStyle(root).getPropertyValue('--cl-stick')) + 1}px 0px 0px` }).observe($('[data-sentinel]'));

      /* ---------- reveal on scroll ---------- */
      const io = 'IntersectionObserver' in window && !reduce ? new IntersectionObserver((entries) => {
        let n = 0;
        entries.filter((e) => e.isIntersecting).forEach((e) => {
          e.target.style.setProperty('--rd', n++ % 5);
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px' }) : null;
      const grid = $('[data-grid]');
      const cards = $$('[data-card]');
      const stories = $$('[data-story]');
      [...cards, ...stories].forEach((el) => (io ? io.observe(el) : el.classList.add('is-in')));

      /* story parallax + video in view */
      const storyMedia = $$('.cl-story__media');
      if (storyMedia.length && !reduce) {
        let tk = false;
        const run = () => {
          tk = false;
          storyMedia.forEach((m) => {
            const r = m.parentElement.getBoundingClientRect();
            if (r.bottom < 0 || r.top > innerHeight) return;
            const p = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
            m.style.transform = `translate3d(0, ${p * -8}%, 0)`;
          });
        };
        addEventListener('scroll', () => { if (!tk) { tk = true; requestAnimationFrame(run); } }, { passive: true });
        run();
      }
      $$('.cl-story video').forEach((v) => {
        v.muted = true;
        new IntersectionObserver(([en]) => { en.isIntersecting && !reduce ? v.play().catch(() => {}) : v.pause(); }).observe(v);
      });

      /* ---------- state ---------- */
      const prices = cards.map((c) => +c.dataset.price);
      const pMin = Math.floor(Math.min(...prices, 0) / 100) * 100;
      const pMax = Math.ceil(Math.max(...prices, 0) / 100) * 100;
      const state = { group: '', q: '', sizes: new Set(), fams: new Set(), min: pMin, max: pMax, instock: false, sale: false, sort: 'featured' };
      const params = new URLSearchParams(location.search);
      state.group = params.get('type') || '';
      state.q = params.get('q') || '';
      (params.get('size') || '').split(',').filter(Boolean).forEach((s) => state.sizes.add(s));
      (params.get('color') || '').split(',').filter(Boolean).forEach((s) => state.fams.add(s));
      if (params.get('min')) state.min = +params.get('min') * 100;
      if (params.get('max')) state.max = +params.get('max') * 100;
      state.instock = params.get('instock') === '1';
      state.sale = params.get('sale') === '1';
      state.sort = params.get('sort') || 'featured';
      if (params.get('cols')) root.dataset[innerWidth < 750 ? 'colsM' : 'cols'] = params.get('cols');

      const matches = (c, ignore) => {
        const d = c.dataset;
        if (ignore !== 'group' && state.group && d.group !== state.group) return false;
        if (state.q) {
          const words = state.q.toLowerCase().split(/\s+/).filter(Boolean);
          if (!words.every((w) => d.title.includes(w))) return false;
        }
        if (state.sizes.size && ![...state.sizes].some((s) => c._sizes.has(s))) return false;
        if (state.fams.size && ![...state.fams].some((f) => d.fams.includes(`|${f}|`))) return false;
        const pr = +d.price;
        if (pr < state.min || pr > state.max) return false;
        if (state.instock && d.avail !== 'true') return false;
        if (state.sale && d.sale !== 'true') return false;
        return true;
      };
      const filtering = () => !!(state.group || state.q || state.sizes.size || state.fams.size || state.min > pMin || state.max < pMax || state.instock || state.sale);

      /* ---------- filter drawer contents ---------- */
      /* sizes: one name per size ("Small" → S, "XS / S" → XS/S), grouped by kind */
      const letterMap = { 'x-small': 'XS', 'xsmall': 'XS', 'small': 'S', 'medium': 'M', 'large': 'L', 'x-large': 'XL', 'xlarge': 'XL', 'one size': 'One size', 'os': 'One size' };
      const norm = (v) => { const k = v.trim().toLowerCase(); return letterMap[k] || v.trim().replace(/\s*\/\s*/g, '/').toUpperCase().replace('ONE SIZE', 'One size'); };
      const kindOf = (v, card) => {
        if (card.dataset.sizeKind === 'shoe') return 3;
        if (/^\d{2}[A-H]{1,3}$/i.test(v)) return 4;
        const n = parseFloat(v);
        if (!isNaN(n) && String(n) === v.replace(/^0+(?=\d)/, '')) return card.dataset.group === 'bottoms' && n >= 22 ? 2 : 1;
        return 0;
      };
      cards.forEach((c) => { c._sizes = new Set(c.dataset.sizes.split('|').filter(Boolean).map(norm)); });
      const byKind = [new Set(), new Set(), new Set(), new Set(), new Set()];
      cards.forEach((c) => c.dataset.sizes.split('|').filter(Boolean).forEach((v) => byKind[kindOf(v, c)].add(norm(v))));
      const letterOrder = ['XXS', 'XS', 'XS/S', 'S', 'S/M', 'M', 'M/L', 'L', 'L/XL', 'XL', 'XXL', 'One size'];
      const sortSizes = (arr) => arr.sort((a, b) => {
        const ia = letterOrder.indexOf(a), ib = letterOrder.indexOf(b);
        if (ia > -1 || ib > -1) return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
        return parseFloat(a) - parseFloat(b) || a.localeCompare(b);
      });
      const kindNames = ($('[data-fset="size"]').dataset.kinds || '').split(',').map((x) => x.trim());
      const sizeList = $('[data-size-list]');
      const sizeHtml = byKind.map((set, k) => set.size ? `<p class="cl-fsub">${kindNames[k] || ''}</p><div class="cl-fchips">${sortSizes([...set]).map((sz) => `<button type="button" class="cl-fchip" data-size="${sz.replace(/"/g, '&quot;')}" aria-pressed="false">${sz}</button>`).join('')}</div>` : '').join('');
      if (sizeHtml) { $('[data-fset="size"]').hidden = false; sizeList.innerHTML = sizeHtml; }
      const famsPresent = new Set(cards.flatMap((c) => c.dataset.fams.split('|').filter(Boolean)));
      $$('[data-fam]').forEach((b) => { b.hidden = !famsPresent.has(b.dataset.fam); });
      if (famsPresent.size) $('[data-fset="color"]').hidden = false;
      if (cards.some((c) => c.dataset.sale === 'true')) $('[data-sale-row]').hidden = false;
      const minIn = $('[data-min]'), maxIn = $('[data-max]');
      [minIn, maxIn].forEach((i) => { i.min = pMin / 100; i.max = pMax / 100; i.step = 5; });

      /* ---------- render ---------- */
      const countEl = $('[data-count]');
      let shownCount = cards.length;
      const animateCount = (to) => {
        const from = shownCount; shownCount = to;
        if (reduce || from === to) { countEl.textContent = to; return; }
        const t0 = performance.now();
        const step = (now) => { const k = Math.min(1, (now - t0) / 450); countEl.textContent = Math.round(from + (to - from) * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); };
        requestAnimationFrame(step);
      };
      const sorters = {
        featured: (a, b) => a.dataset.i - b.dataset.i,
        newest: (a, b) => b.dataset.date - a.dataset.date || a.dataset.i - b.dataset.i,
        'price-asc': (a, b) => a.dataset.price - b.dataset.price || a.dataset.i - b.dataset.i,
        'price-desc': (a, b) => b.dataset.price - a.dataset.price || a.dataset.i - b.dataset.i,
        title: (a, b) => a.dataset.title.localeCompare(b.dataset.title),
      };
      const glider = $('[data-glider]');
      const moveGlider = () => {
        const on = $('.cl-chip.is-on');
        if (!glider || !on) return;
        glider.style.width = `${on.offsetWidth}px`;
        glider.style.transform = `translateX(${on.offsetLeft}px)`;
      };
      const syncControls = () => {
        $$('.cl-chip').forEach((c) => { const on = c.dataset.group === state.group; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', String(on)); });
        moveGlider();
        $$('[data-size]').forEach((b) => b.setAttribute('aria-pressed', String(state.sizes.has(b.dataset.size))));
        $$('[data-fam]').forEach((b) => b.setAttribute('aria-pressed', String(state.fams.has(b.dataset.fam))));
        minIn.value = state.min / 100; maxIn.value = state.max / 100;
        const span = pMax - pMin || 1;
        const fill = $('[data-range-fill]');
        fill.style.left = `${((state.min - pMin) / span) * 100}%`;
        fill.style.right = `${100 - ((state.max - pMin) / span) * 100}%`;
        $('[data-min-out]').textContent = money(state.min);
        $('[data-max-out]').textContent = money(state.max);
        $('[data-instock]').checked = state.instock;
        $('[data-onsale]').checked = state.sale;
        $('[data-sort]').value = state.sort;
        const search = $('[data-search]');
        if (search && search.value !== state.q) search.value = state.q;
        const n = state.sizes.size + state.fams.size + (state.min > pMin || state.max < pMax ? 1 : 0) + (state.instock ? 1 : 0) + (state.sale ? 1 : 0);
        const nb = $('[data-filter-n]'); nb.hidden = !n; nb.textContent = n;
        $$('[data-cols-btn]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.colsBtn === root.dataset.cols || b.dataset.colsBtn === `${root.dataset.colsM}m` || (b.dataset.colsBtn === '1' && root.dataset.colsM === '1'))));
      };
      const pills = () => {
        const box = $('[data-active]');
        const items = [];
        const x = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7l10 10M17 7 7 17"/></svg>';
        state.sizes.forEach((s) => items.push(`<button type="button" class="cl-pill" data-rm="size" data-v="${s}">${s} ${x}</button>`));
        state.fams.forEach((f) => items.push(`<button type="button" class="cl-pill" data-rm="fam" data-v="${f}">${$(`[data-fam="${f}"]`)?.textContent.trim() || f} ${x}</button>`));
        if (state.min > pMin || state.max < pMax) items.push(`<button type="button" class="cl-pill" data-rm="price">${money(state.min)} – ${money(state.max)} ${x}</button>`);
        if (state.instock) items.push(`<button type="button" class="cl-pill" data-rm="instock">${$('[data-instock]').parentElement.textContent.trim()} ${x}</button>`);
        if (state.sale) items.push(`<button type="button" class="cl-pill" data-rm="sale">${$('[data-onsale]').parentElement.textContent.trim()} ${x}</button>`);
        if (state.q) items.push(`<button type="button" class="cl-pill" data-rm="q">“${state.q.replace(/</g, '&lt;')}” ${x}</button>`);
        if (items.length > 1) items.push(`<button type="button" class="cl-pill cl-pill--clear" data-clear>${$('[data-clear]').textContent.trim()}</button>`);
        box.innerHTML = items.join('');
        box.hidden = !items.length;
      };
      const writeUrl = () => {
        const u = new URL(location.href);
        const set = (k, v) => (v ? u.searchParams.set(k, v) : u.searchParams.delete(k));
        set('type', state.group); set('q', state.q);
        set('size', [...state.sizes].join(',')); set('color', [...state.fams].join(','));
        set('min', state.min > pMin ? state.min / 100 : ''); set('max', state.max < pMax ? state.max / 100 : '');
        set('instock', state.instock ? '1' : ''); set('sale', state.sale ? '1' : '');
        set('sort', state.sort === 'featured' ? '' : state.sort);
        history.replaceState(history.state, '', u);
      };
      const chipCounts = () => {
        $$('.cl-chip').forEach((c) => {
          const g = c.dataset.group;
          const n = cards.filter((card) => (!g || card.dataset.group === g) && matches(card, 'group')).length;
          c.querySelector('[data-chip-count]').textContent = n;
          c.hidden = !!g && !cards.some((card) => card.dataset.group === g);
        });
      };

      const apply = (opts = {}) => {
        const animate = !reduce && opts.animate !== false;
        const visibleBefore = animate ? new Map([...cards, ...stories].filter((el) => !el.classList.contains('is-hidden')).map((el) => [el, el.getBoundingClientRect()])) : new Map();
        const showStories = !(root.dataset.hideStories === 'true' && (filtering() || state.sort !== 'featured'));
        const list = cards.slice().sort(sorters[state.sort] || sorters.featured);
        let n = 0;
        const frag = document.createDocumentFragment();
        list.forEach((c) => {
          const ok = matches(c);
          c.classList.toggle('is-hidden', !ok);
          if (ok) n++;
          frag.append(c);
        });
        grid.append(frag);
        // stories go back to their slots among the visible products
        stories.forEach((s) => {
          s.classList.toggle('is-hidden', !showStories);
          if (!showStories) return;
          const pos = +s.dataset.position;
          const vis = list.filter((c) => !c.classList.contains('is-hidden'));
          const before = vis[pos - 1];
          before ? grid.insertBefore(s, before) : grid.append(s);
        });
        $('[data-empty]').hidden = n > 0;
        animateCount(n);
        $('[data-count-label]').textContent = n === 1 ? t('tCountOne') : t('tCount');
        const showText = $('[data-show-text]');
        showText.textContent = showText.dataset.t.replace('[count]', n);
        syncControls(); pills(); chipCounts(); writeUrl();
        if (!animate) return;
        // FLIP: slide kept items from their old spot, fade new ones in
        [...cards, ...stories].forEach((el) => {
          if (el.classList.contains('is-hidden')) return;
          el.classList.add('is-in');
          io?.unobserve(el);
          const old = visibleBefore.get(el);
          const now = el.getBoundingClientRect();
          if (now.bottom < -200 || now.top > innerHeight + 200) return;
          if (old) {
            const dx = old.left - now.left, dy = old.top - now.top;
            if (Math.abs(dx) < 1 && Math.abs(dy) < 1) return;
            el.animate([{ transform: `translate(${dx}px, ${dy}px)` }, { transform: 'none' }], { duration: 550, easing: EASE });
          } else {
            el.animate([{ opacity: 0, transform: 'translateY(18px) scale(.97)' }, { opacity: 1, transform: 'none' }], { duration: 500, easing: EASE, delay: Math.min(8, Math.floor(now.top / 200)) * 25 });
          }
        });
      };
      const go = (fn) => () => { fn(); apply(); };
      const scrollToGrid = () => { if (bar.getBoundingClientRect().top > parseFloat(getComputedStyle(root).getPropertyValue('--cl-stick')) + 4) return; window.scrollTo({ top: bar.offsetTop - parseFloat(getComputedStyle(root).getPropertyValue('--cl-stick')) + 1, behavior: reduce ? 'auto' : 'smooth' }); };

      $$('.cl-chip').forEach((c) => c.addEventListener('click', () => { state.group = c.dataset.group; apply(); scrollToGrid(); c.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' }); }));
      let qT;
      $('[data-search]')?.addEventListener('input', (e) => { clearTimeout(qT); qT = setTimeout(() => { state.q = e.target.value.trim(); apply(); }, 160); });
      sizeList.addEventListener('click', (e) => { const b = e.target.closest('[data-size]'); if (!b) return; const s = b.dataset.size; state.sizes.has(s) ? state.sizes.delete(s) : state.sizes.add(s); apply(); });
      $$('[data-fam]').forEach((b) => b.addEventListener('click', go(() => { const f = b.dataset.fam; state.fams.has(f) ? state.fams.delete(f) : state.fams.add(f); })));
      let rT;
      const onRange = (e) => {
        let lo = +minIn.value * 100, hi = +maxIn.value * 100;
        if (lo > hi) { if (e.target === minIn) lo = hi; else hi = lo; }
        state.min = lo; state.max = hi; syncControls();
        clearTimeout(rT); rT = setTimeout(apply, 120);
      };
      minIn.addEventListener('input', onRange); maxIn.addEventListener('input', onRange);
      $('[data-instock]').addEventListener('change', (e) => { state.instock = e.target.checked; apply(); });
      $('[data-onsale]').addEventListener('change', (e) => { state.sale = e.target.checked; apply(); });
      $('[data-sort]').addEventListener('change', (e) => { state.sort = e.target.value; apply(); });
      const clearAll = () => { Object.assign(state, { group: '', q: '', min: pMin, max: pMax, instock: false, sale: false }); state.sizes.clear(); state.fams.clear(); apply(); };
      root.addEventListener('click', (e) => {
        if (e.target.closest('[data-clear]')) { clearAll(); return; }
        const rm = e.target.closest('[data-rm]');
        if (!rm) return;
        const k = rm.dataset.rm, v = rm.dataset.v;
        if (k === 'size') state.sizes.delete(v);
        if (k === 'fam') state.fams.delete(v);
        if (k === 'price') { state.min = pMin; state.max = pMax; }
        if (k === 'instock') state.instock = false;
        if (k === 'sale') state.sale = false;
        if (k === 'q') state.q = '';
        apply();
      });
      $$('[data-cols-btn]').forEach((b) => b.addEventListener('click', () => {
        const v = b.dataset.colsBtn;
        const before = new Map(cards.filter((c) => !c.classList.contains('is-hidden')).map((c) => [c, c.getBoundingClientRect()]));
        if (v.endsWith('m')) root.dataset.colsM = v[0]; else if (v === '1') root.dataset.colsM = '1'; else root.dataset.cols = v;
        const u = new URL(location.href); u.searchParams.set('cols', v.replace('m', '')); history.replaceState(history.state, '', u);
        syncControls();
        if (reduce) return;
        before.forEach((old, el) => {
          const now = el.getBoundingClientRect();
          if (now.bottom < -200 || now.top > innerHeight + 200) return;
          el.animate([{ transform: `translate(${old.left - now.left}px, ${old.top - now.top}px) scale(${old.width / now.width})`, transformOrigin: '0 0' }, { transform: 'none', transformOrigin: '0 0' }], { duration: 600, easing: EASE });
        });
      }));
      const chipsEl = $('[data-chips]');
      const edges = () => { if (!chipsEl) return; chipsEl.classList.toggle('is-more-l', chipsEl.scrollLeft > 4); chipsEl.classList.toggle('is-more-r', chipsEl.scrollLeft + chipsEl.clientWidth < chipsEl.scrollWidth - 4); };
      chipsEl?.addEventListener('scroll', edges, { passive: true });
      addEventListener('resize', () => { moveGlider(); edges(); }, { passive: true });
      edges();
      document.fonts?.ready.then(moveGlider);

      /* drawer */
      const drawer = $('[data-drawer]');
      $('[data-open-filters]').addEventListener('click', () => drawer.showModal());
      $$('[data-drawer-close]').forEach((b) => b.addEventListener('click', () => drawer.close()));
      drawer.addEventListener('click', (e) => { if (e.target === drawer) drawer.close(); });

      /* ---------- quick add ---------- */
      const variantsOf = (rootEl) => JSON.parse(rootEl.querySelector('[data-qa-json]')?.textContent || '[]');
      const sizeButtons = (rootEl, color) => {
        const box = rootEl.querySelector('[data-qa-sizes]');
        if (!box) return;
        const data = variantsOf(rootEl);
        const ci = +box.dataset.ci, si = +box.dataset.si;
        const vs = data.v.filter((v) => ci < 0 || !color || v.o[ci] === color);
        if (si < 0) {
          const v = vs.find((x) => x.a) || vs[0];
          box.innerHTML = `<button type="button" class="cl-qa__size cl-qa__size--wide" data-vid="${v.id}" ${v.a ? '' : 'disabled'}>${v.a ? t('tAdd') : t('tSold')}</button>`;
          return;
        }
        const seen = new Set();
        box.innerHTML = vs.filter((v) => !seen.has(v.o[si]) && seen.add(v.o[si])).map((v) => {
          const avail = vs.some((x) => x.o[si] === v.o[si] && x.a);
          const id = (vs.find((x) => x.o[si] === v.o[si] && x.a) || v).id;
          return `<button type="button" class="cl-qa__size" data-vid="${id}" ${avail ? '' : 'disabled'} aria-label="${t('tAdd')} ${v.o[si]}">${v.o[si]}</button>`;
        }).join('');
      };
      $$('[data-qa-root]').forEach((r) => { if (r.querySelector('[data-qa-sizes]')) sizeButtons(r, r.closest('[data-card]')?.querySelector('.cl-dot.is-on')?.dataset.dot || ''); });
      root.addEventListener('click', async (e) => {
        const b = e.target.closest('[data-vid]');
        if (!b || b.disabled) return;
        e.preventDefault();
        b.classList.add('is-busy');
        try {
          await addToCart(+b.dataset.vid, b);
          b.classList.remove('is-busy'); b.classList.add('is-done');
          toast(`${t('tAdded')} · ${b.textContent.trim()}`);
          setTimeout(() => b.classList.remove('is-done'), 1600);
          if (b.closest('[data-sheet]')) setTimeout(() => $('[data-sheet]').close(), 500);
        } catch (err) { b.classList.remove('is-busy'); toast(err.message); }
      });

      /* color dots swap the photo and the sizes */
      root.addEventListener('click', (e) => {
        const dot = e.target.closest('[data-dot]');
        if (!dot) return;
        const card = dot.closest('[data-card]');
        card.querySelectorAll('[data-dot]').forEach((d) => d.classList.toggle('is-on', d === dot));
        const qa = card.querySelector('[data-qa-root]');
        const data = variantsOf(qa);
        const v = data.v.find((x) => x.o[data.ci] === dot.dataset.dot && x.img);
        const img = card.querySelector('[data-card-img]');
        if (v && img) { img.removeAttribute('srcset'); img.src = v.img; img.classList.remove('is-swap'); img.offsetWidth; img.classList.add('is-swap'); }
        sizeButtons(qa, dot.dataset.dot);
      });

      /* phone sheet */
      const sheet = $('[data-sheet]');
      root.addEventListener('click', (e) => {
        const open = e.target.closest('[data-qa-open]');
        if (!open) return;
        const card = open.closest('[data-card]');
        const qa = card.querySelector('[data-qa-root]');
        const data = variantsOf(qa);
        const img = card.querySelector('[data-card-img]');
        const title = card.querySelector('.cl-card__title').innerHTML;
        const price = card.querySelector('.cl-card__price').innerHTML;
        const dots = card.querySelector('[data-dots]');
        const body = $('[data-sheet-body]');
        body.innerHTML = `<div class="cl-sheet__top">${img ? `<img src="${img.currentSrc || img.src}" alt="">` : ''}<div><p class="cl-card__title">${title}</p><p class="cl-card__price">${price}</p></div></div>${dots ? `<div class="cl-dots" style="margin-top:14px">${dots.innerHTML}</div>` : ''}<div data-qa-root><script type="application/json" data-qa-json>${JSON.stringify(data)}<\/script><div class="cl-qa__sizes" data-qa-sizes data-ci="${qa.querySelector('[data-qa-sizes]').dataset.ci}" data-si="${qa.querySelector('[data-qa-sizes]').dataset.si}"></div></div>`;
        const sqa = body.querySelector('[data-qa-root]');
        const current = card.querySelector('.cl-dot.is-on')?.dataset.dot || '';
        sizeButtons(sqa, current);
        body.querySelectorAll('[data-dot]').forEach((d) => d.addEventListener('click', (ev) => {
          ev.stopPropagation();
          body.querySelectorAll('[data-dot]').forEach((x) => x.classList.toggle('is-on', x === d));
          sizeButtons(sqa, d.dataset.dot);
        }));
        sheet.showModal();
      });
      $('[data-sheet-close]').addEventListener('click', () => sheet.close());
      sheet.addEventListener('click', (e) => { if (e.target === sheet) sheet.close(); });

      apply({ animate: false });
    };

    const boot = () => document.querySelectorAll('.jttp-cl').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('.jttp-cl')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jttp-community-calendar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DAY = 864e5;
    const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    // Scraped data is untrusted: only ever link to http(s) and protocol-relative/root-relative URLs.
    const safeUrl = (u) => {
      u = String(u || '').trim();
      const t = u.replace(/[\x00-\x20]/g, '');
      return /^[a-z][a-z0-9+.-]*:/i.test(t) && !/^https?:/i.test(t) ? '' : u;
    };
    const ICON = {
      clock: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/></svg>',
      pin: '<svg viewBox="0 0 24 24"><path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg>',
      cal: '<svg viewBox="0 0 24 24"><rect x="3.5" y="5" width="17" height="15.5" rx="2"/><path d="M3.5 10h17M8 3v4M16 3v4"/></svg>',
      tag: '<svg viewBox="0 0 24 24"><path d="M3.5 12.5V4.5a1 1 0 0 1 1-1h8l8 8-9 9z"/><circle cx="8.5" cy="8.5" r="1.5"/></svg>',
      repeat: '<svg viewBox="0 0 24 24"><path d="M17 2l3 3-3 3"/><path d="M4 11V9a4 4 0 0 1 4-4h12M7 22l-3-3 3-3"/><path d="M20 13v2a4 4 0 0 1-4 4H4"/></svg>',
      close: '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg>',
      prev: '<svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg>',
      next: '<svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg>',
      ext: '<svg viewBox="0 0 24 24"><path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"/></svg>',
    };

    // "YYYY-MM-DD" day keys; noon UTC keeps day arithmetic clear of DST edges.
    const kd = (k) => new Date(k + 'T12:00:00Z');
    const dk = (d) => d.toISOString().slice(0, 10);
    const addDays = (k, n) => dk(new Date(kd(k).getTime() + n * DAY));
    const fmt = (k, o) => kd(k).toLocaleDateString('en-US', { timeZone: 'UTC', ...o });
    const timeLabel = (m) => {
      const h = Math.floor(m / 60), mm = m % 60, ap = h >= 12 ? 'pm' : 'am', h12 = h % 12 || 12;
      return mm ? `${h12}:${String(mm).padStart(2, '0')}${ap}` : `${h12}${ap}`;
    };
    const hhmm = (s) => { const m = /^(\d{1,2}):?(\d{2})?\s*(am|pm)?$/i.exec(String(s || '').trim()); if (!m) return null; let h = +m[1]; const ap = (m[3] || '').toLowerCase(); if (ap === 'pm' && h < 12) h += 12; if (ap === 'am' && h === 12) h = 0; return h * 60 + (+m[2] || 0); };
    const stamp = (k, m) => k.replace(/-/g, '') + (m == null ? '' : `T${String(Math.floor(m / 60)).padStart(2, '0')}${String(m % 60).padStart(2, '0')}00`);

    const init = (root) => {
      if (root.dataset.calReady) return;
      root.dataset.calReady = '1';
      const read = (sel, fb) => { try { return JSON.parse(root.querySelector(sel)?.textContent || '') ; } catch (e) { return fb; } };
      const L = read('[data-cal-labels]', {});
      const tz = root.dataset.tz || 'America/Los_Angeles';
      const listDays = +root.dataset.listDays || 90;
      const jttpAddress = root.dataset.address || '';
      const stage = root.querySelector('[data-cal-stage]');
      const dlg = root.querySelector('.cal-dlg');
      const dlgInner = root.querySelector('[data-cal-dlg]');
      const featureEl = root.querySelector('[data-cal-feature]');
      const catSel = root.querySelector('[data-cal-cat]');

      const pf = new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
      const where = (d) => { const o = {}; pf.formatToParts(d).forEach((p) => { o[p.type] = p.value; }); return { key: `${o.year}-${o.month}-${o.day}`, min: (+o.hour % 24) * 60 + +o.minute }; };
      const parseDate = (s) => { if (!s) return null; const d = new Date(String(s).replace(/([+-]\d{2})(\d{2})$/, '$1:$2').replace(' ', 'T')); return isNaN(d) ? null : d; };
      const now = where(new Date());
      const today = now.key;

      /* ---------- normalise ---------- */
      const events = [];
      read('[data-cal-events]', []).forEach((r) => {
        const s = parseDate(r.start); if (!s || !r.title) return;
        const e = parseDate(r.end);
        const a = where(s), b = e && e > s ? where(e) : null;
        events.push({
          id: r.id, title: r.title, host: r.host === 'jttp' ? 'jttp' : 'community', cat: r.cat || '',
          venue: r.venue || '', address: r.address || '', town: r.town || '', desc: r.desc || '',
          url: safeUrl(r.url), urlLabel: r.urlLabel || '', price: r.price || '', img: safeUrl(r.img),
          src: r.src || '', srcUrl: safeUrl(r.srcUrl), featured: !!r.featured, allDay: !!r.allDay,
          startKey: a.key, startMin: r.allDay ? null : a.min,
          endKey: b ? (r.allDay || b.min > 0 ? b.key : addDays(b.key, -1)) : a.key, endMin: b && !r.allDay ? b.min : null,
        });
      });

      const occ = []; // { ev, key, min, cont }
      events.forEach((ev) => {
        let k = ev.startKey, n = 0;
        const last = ev.endKey < ev.startKey ? ev.startKey : ev.endKey;
        while (k <= last && n < 62) { occ.push({ ev, key: k, min: k === ev.startKey ? (ev.startMin ?? -1) : -1, cont: k !== ev.startKey }); k = addDays(k, 1); n++; }
      });

      // Recurring blocks → occurrences from 6 weeks back to 13 months out.
      const winStart = addDays(today, -42), winEnd = addDays(today, 400);
      read('[data-cal-recurring]', []).forEach((r) => {
        const days = String(r.days || '').split(',').filter(Boolean).map(Number);
        if (!r.title || !days.length) return;
        const sm = hhmm(r.startTime), em = hhmm(r.endTime);
        const skip = new Set(String(r.skip || '').split(/[\s,]+/).filter(Boolean));
        const dayNames = [...days].sort((a, b) => ((a + 6) % 7) - ((b + 6) % 7)).map((d) => fmt(addDays('2026-01-04', d), { weekday: 'short' })); // 2026-01-04 is a Sunday
        const ev = {
          id: r.id, title: r.title, host: r.host === 'community' ? 'community' : 'jttp', cat: r.cat || '',
          venue: r.venue || '', address: r.address || '', town: '', desc: r.desc || '', url: safeUrl(r.url),
          urlLabel: r.urlLabel || '', price: r.price || '', img: safeUrl(r.img), src: '', srcUrl: '',
          recurring: `${L.weekly || 'Every'} ${dayNames.join(' & ')}`, allDay: sm == null, startMin: sm, endMin: em,
        };
        const from = /^\d{4}-\d{2}-\d{2}$/.test(r.from) && r.from > winStart ? r.from : winStart;
        const until = /^\d{4}-\d{2}-\d{2}$/.test(r.until) && r.until < winEnd ? r.until : winEnd;
        for (let k = from; k <= until; k = addDays(k, 1)) {
          if (days.includes(kd(k).getUTCDay()) && !skip.has(k)) occ.push({ ev, key: k, min: sm ?? -1, cont: false, rec: true });
        }
      });
      occ.sort((a, b) => (a.key < b.key ? -1 : a.key > b.key ? 1 : 0) || (a.ev.host === b.ev.host ? 0 : a.ev.host === 'jttp' ? -1 : 1) || a.min - b.min);

      // Category filter options
      const cats = [...new Set(occ.map((o) => o.ev.cat).filter(Boolean))].sort();
      cats.forEach((c) => catSel?.insertAdjacentHTML('beforeend', `<option>${esc(c)}</option>`));
      if (catSel && !cats.length) catSel.closest('label').hidden = true;

      /* ---------- state ---------- */
      const state = { host: 'all', cat: '', view: root.dataset.view === 'month' ? 'month' : 'list', month: today.slice(0, 7), day: today, shown: listDays };
      try { const v = localStorage.getItem('jttp-cal-view'); if (v === 'list' || v === 'month') state.view = v; } catch (e) {}
      // Deep link: ?date=YYYY-MM-DD opens the month view on that day (used by the Field Notes emails).
      const linkDay = new URLSearchParams(location.search).get('date');
      const deepDay = /^\d{4}-\d{2}-\d{2}$/.test(linkDay || '') ? linkDay : null;
      if (deepDay) { state.view = 'month'; state.day = deepDay; state.month = deepDay.slice(0, 7); }
      const pass = (o) => (state.host === 'all' || o.ev.host === state.host) && (!state.cat || o.ev.cat === state.cat);

      /* ---------- formatting ---------- */
      const whenText = (o, long) => {
        const ev = o.ev;
        const d = long ? fmt(o.key, { weekday: 'long', month: 'long', day: 'numeric' }) : '';
        let t;
        if (ev.allDay || o.min < 0) t = o.cont ? `${L.allDay} · ${fmt(ev.startKey, { month: 'short', day: 'numeric' })}–${fmt(ev.endKey, { month: 'short', day: 'numeric' })}` : (ev.endKey && ev.endKey !== ev.startKey && !o.rec ? `${L.allDay}, through ${fmt(ev.endKey, { month: 'short', day: 'numeric' })}` : L.allDay);
        else t = timeLabel(o.min) + (ev.endMin != null ? `–${timeLabel(ev.endMin)}` : '') + (!o.rec && ev.endKey !== ev.startKey ? `, through ${fmt(ev.endKey, { month: 'short', day: 'numeric' })}` : '');
        return long ? `${d} · ${t}` : t;
      };
      const place = (ev) => [ev.venue, ev.town].filter(Boolean).join(', ');
      // Venue, address, town — skipping the venue or town when the address already contains it.
      const fullLoc = (ev) => {
        const addr = ev.address || (ev.host === 'jttp' ? jttpAddress : '');
        const has = (part) => part && addr.toLowerCase().includes(part.toLowerCase());
        return [has(ev.venue) ? '' : ev.venue, addr, has(ev.town) ? '' : ev.town].filter(Boolean).join(', ');
      };
      const dayRel = (k) => (k === today ? L.today : k === addDays(today, 1) ? L.tomorrow : '');

      const jttpCard = (o, i) => `
        <button type="button" class="cal-ev cal-ev--jttp${o.ev.img ? '' : ' no-img'}" data-cal-open="${i}">
          <span class="cal-ev__media${o.ev.img ? '' : ' cal-ev__media--logo'}">${o.ev.img ? `<img src="${esc(o.ev.img)}" alt="" loading="lazy">` : 'JTTP'}</span>
          <span class="cal-ev__body">
            <span class="cal-badge">${esc(L.jttp)}</span>
            <span class="cal-ev__title">${esc(o.ev.title)}</span>
            <span class="cal-ev__meta">
              <span>${ICON.clock}${esc(whenText(o))}</span>
              ${place(o.ev) ? `<span>${ICON.pin}${esc(place(o.ev))}</span>` : ''}
              ${o.ev.recurring ? `<span>${ICON.repeat}${esc(o.ev.recurring)}</span>` : ''}
            </span>
            ${o.ev.desc ? `<span class="cal-ev__desc">${esc(o.ev.desc)}</span>` : ''}
          </span>
        </button>`;
      const comRow = (o, i) => `
        <button type="button" class="cal-ev cal-ev--com" data-cal-open="${i}">
          <span class="cal-ev__time">${esc(o.ev.allDay || o.min < 0 ? L.allDay : timeLabel(o.min))}</span>
          <span><span class="cal-ev__title">${esc(o.ev.title)}</span>${place(o.ev) ? `<span class="cal-ev__sub" style="display:block">${esc(place(o.ev))}</span>` : ''}</span>
          ${o.ev.cat ? `<span class="cal-tag">${esc(o.ev.cat)}</span>` : ''}
        </button>`;

      let rendered = []; // occurrence lookup for data-cal-open
      const item = (o) => { rendered.push(o); const i = rendered.length - 1; return o.ev.host === 'jttp' ? jttpCard(o, i) : comRow(o, i); };
      const dayBlock = (k, list) => `
        <section class="cal-day" aria-label="${esc(fmt(k, { weekday: 'long', month: 'long', day: 'numeric' }))}">
          <div class="cal-day__label"><div>
            <span class="cal-day__dow">${esc(fmt(k, { weekday: 'long' }))}</span>
            <span class="cal-day__date">${esc(fmt(k, { month: 'short', day: 'numeric' }))}</span>
            ${dayRel(k) ? `<span class="cal-day__rel">${esc(dayRel(k))}</span>` : ''}
          </div></div>
          <div class="cal-day__items">${list.map(item).join('')}</div>
        </section>`;

      /* ---------- featured ---------- */
      const renderFeature = () => {
        if (!featureEl) return;
        const horizon = addDays(today, 60);
        const up = occ.filter((o) => o.ev.host === 'jttp' && !o.cont && o.key >= today && o.key <= horizon && !(o.key === today && o.ev.endMin != null && o.ev.endMin < now.min));
        const pick = up.find((o) => o.ev.featured) || up.find((o) => !o.rec) || up[0];
        if (!pick) { featureEl.hidden = true; return; }
        rendered.push(pick);
        const i = rendered.length - 1, ev = pick.ev;
        featureEl.innerHTML = `
          <div class="cal-feature__media">${ev.img ? `<img src="${esc(ev.img)}" alt="" loading="eager">` : `<div class="cal-feature__date"><span>${esc(fmt(pick.key, { month: 'short' }))}</span><b>${esc(fmt(pick.key, { day: 'numeric' }))}</b></div>`}</div>
          <div class="cal-feature__body">
            <p class="cal-feature__kicker">${esc(L.featured)}</p>
            <h2 class="cal-feature__title">${esc(ev.title)}</h2>
            <p class="cal-feature__when">${esc(whenText(pick, true))}</p>
            ${ev.desc ? `<p class="cal-feature__desc">${esc(ev.desc)}</p>` : ''}
            <div class="cal-feature__actions">
              <button type="button" class="cal-btn cal-btn--light" data-cal-open="${i}">${esc(L.details)}</button>
              ${ev.url ? `<a class="cal-btn cal-btn--outline-light" href="${esc(ev.url)}">${esc(ev.urlLabel || L.link)}</a>` : ''}
            </div>
          </div>`;
        featureEl.hidden = false;
      };

      /* ---------- list ---------- */
      const renderList = () => {
        const end = addDays(today, state.shown);
        const groups = new Map();
        // Multi-day events show once: on their first day, or today if already running.
        occ.forEach((o) => {
          if (!pass(o) || o.key > end) return;
          const running = o.cont && o.key === today;
          if (o.key < today || (o.cont && !running)) return;
          if (!groups.has(o.key)) groups.set(o.key, []);
          groups.get(o.key).push(o);
        });
        const more = occ.some((o) => pass(o) && !o.cont && o.key > end);
        stage.innerHTML = groups.size
          ? [...groups].map(([k, l]) => dayBlock(k, l)).join('') + (more ? `<div class="cal-more"><button type="button" class="cal-btn cal-btn--ghost" data-cal-more>${esc(L.more)}</button></div>` : '')
          : `<p class="cal-empty">${esc(L.empty)}</p>`;
      };

      /* ---------- month ---------- */
      const renderMonth = () => {
        const first = state.month + '-01';
        const start = addDays(first, -kd(first).getUTCDay());
        const byDay = new Map();
        occ.forEach((o) => { if (pass(o)) { if (!byDay.has(o.key)) byDay.set(o.key, []); byDay.get(o.key).push(o); } });
        let cells = '';
        for (let i = 0; i < 42; i++) {
          const k = addDays(start, i);
          if (i === 35 && k.slice(0, 7) !== state.month) break; // drop an all-next-month 6th row
          const l = byDay.get(k) || [];
          const j = l.filter((o) => o.ev.host === 'jttp'), c = l.filter((o) => o.ev.host !== 'jttp');
          const room = Math.max(0, 3 - j.length), shownC = c.slice(0, room), extra = l.length - j.length - shownC.length;
          const label = `${fmt(k, { weekday: 'long', month: 'long', day: 'numeric' })}${l.length ? `, ${l.length} event${l.length > 1 ? 's' : ''}` : ''}`;
          cells += `<button type="button" class="cal-cell${k.slice(0, 7) !== state.month ? ' is-out' : ''}${k === today ? ' is-today' : ''}${k < today ? ' is-past' : ''}" data-cal-day="${k}" aria-pressed="${k === state.day}" aria-label="${esc(label)}">
            <span class="cal-cell__n">${+k.slice(8)}</span>
            ${j.map((o) => `<span class="cal-pill cal-pill--jttp">${esc(o.ev.title)}</span>`).join('')}
            ${shownC.map((o) => `<span class="cal-pill cal-pill--com">${esc(o.ev.title)}</span>`).join('')}
            ${extra > 0 ? `<span class="cal-pill cal-pill--more">+${extra} more</span>` : ''}
            <span class="cal-dots" aria-hidden="true">${j.length ? '<i class="is-jttp"></i>' : ''}${c.slice(0, 4).map(() => '<i></i>').join('')}</span>
          </button>`;
        }
        const dow = [0, 1, 2, 3, 4, 5, 6].map((d) => `<div class="cal-dow" aria-hidden="true">${esc(fmt(addDays('2026-01-04', d), { weekday: 'short' }))}</div>`).join('');
        const sel = (byDay.get(state.day) || []);
        stage.innerHTML = `
          <div class="cal-mhead">
            <h2>${esc(fmt(first, { month: 'long', year: 'numeric' }))}</h2>
            <div class="cal-mnav">
              ${state.month !== today.slice(0, 7) ? `<button type="button" class="cal-btn cal-btn--ghost cal-btn--sm" data-cal-month="today">${esc(L.today)}</button>` : ''}
              <button type="button" class="cal-iconbtn" data-cal-month="-1" aria-label="Previous month">${ICON.prev}</button>
              <button type="button" class="cal-iconbtn" data-cal-month="1" aria-label="Next month">${ICON.next}</button>
            </div>
          </div>
          <div class="cal-grid">${dow}${cells}</div>
          <div class="cal-dayview">${sel.length ? dayBlock(state.day, sel) : ''}</div>`;
      };

      const render = () => {
        rendered = [];
        renderFeature();
        root.querySelectorAll('[data-cal-view]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.calView === state.view)));
        root.querySelectorAll('[data-cal-host]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.calHost === state.host)));
        state.view === 'month' ? renderMonth() : renderList();
      };

      /* ---------- detail dialog ---------- */
      const gcal = (o) => {
        const ev = o.ev, timed = !(ev.allDay || o.min < 0);
        const sKey = o.cont ? ev.startKey : o.key;
        const eKey = o.rec ? o.key : ev.endKey || sKey;
        const s = timed ? stamp(sKey, o.min) : stamp(sKey);
        const e = timed ? (ev.endMin != null ? stamp(eKey, ev.endMin) : stamp(sKey, Math.min(o.min + 120, 1439))) : stamp(addDays(eKey, 1));
        const loc = fullLoc(ev);
        const q = new URLSearchParams({ action: 'TEMPLATE', text: ev.title, dates: `${s}/${e}`, ctz: tz, details: [ev.desc, ev.url].filter(Boolean).join('\n\n'), location: loc });
        return { href: `https://calendar.google.com/calendar/render?${q}`, s, e, timed, loc };
      };
      const ics = (o) => {
        const g = gcal(o), ev = o.ev;
        const t = (v) => String(v || '').replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/[,;]/g, (c) => '\\' + c);
        const lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//JT Trading Post//Community Calendar//EN', 'BEGIN:VEVENT',
          `UID:${ev.id}-${o.key}@jttradingpost.com`, `DTSTAMP:${new Date().toISOString().replace(/[-:]/g, '').slice(0, 15)}Z`,
          g.timed ? `DTSTART;TZID=${tz}:${g.s}` : `DTSTART;VALUE=DATE:${g.s}`,
          g.timed ? `DTEND;TZID=${tz}:${g.e}` : `DTEND;VALUE=DATE:${g.e}`,
          `SUMMARY:${t(ev.title)}`, g.loc ? `LOCATION:${t(g.loc)}` : '', ev.desc ? `DESCRIPTION:${t(ev.desc)}` : '', ev.url ? `URL:${ev.url}` : '',
          'END:VEVENT', 'END:VCALENDAR'].filter(Boolean);
        return URL.createObjectURL(new Blob([lines.join('\r\n')], { type: 'text/calendar' }));
      };
      let lastFocus = null, blobUrl = '';
      const open = (o) => {
        const ev = o.ev, g = gcal(o);
        if (blobUrl) URL.revokeObjectURL(blobUrl);
        blobUrl = ics(o);
        const mapQ = fullLoc(ev);
        const slug = ev.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'event';
        dlgInner.innerHTML = `
          <button type="button" class="cal-dlg__close" data-cal-close aria-label="${esc(L.close)}">${ICON.close}</button>
          ${ev.img ? `<div class="cal-dlg__media"><img src="${esc(ev.img)}" alt=""></div>` : ''}
          <div class="cal-dlg__body${ev.img ? '' : ' no-media'}">
            <span class="cal-badge${ev.host === 'jttp' ? '' : ' cal-badge--com'}">${esc(ev.host === 'jttp' ? L.jttp : (ev.cat || L.community))}</span>
            <h2 class="cal-dlg__title" id="${root.id}-dlg-title">${esc(ev.title)}</h2>
            <ul class="cal-dlg__facts">
              <li>${ICON.cal}<span>${esc(whenText(o, true))}</span></li>
              ${ev.recurring ? `<li>${ICON.repeat}<span>${esc(ev.recurring)}</span></li>` : ''}
              ${mapQ ? `<li>${ICON.pin}<a href="https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(mapQ)}" target="_blank" rel="noopener">${esc(mapQ)}</a></li>` : ''}
              ${ev.price ? `<li>${ICON.tag}<span>${esc(ev.price)}</span></li>` : ''}
            </ul>
            ${ev.desc ? `<p class="cal-dlg__desc">${esc(ev.desc)}</p>` : ''}
            <div class="cal-dlg__actions">
              ${ev.url ? `<a class="cal-btn cal-btn--solid" href="${esc(ev.url)}"${ev.host === 'jttp' ? '' : ' target="_blank" rel="noopener nofollow"'}>${esc(ev.urlLabel || L.link)}${ev.host === 'jttp' ? '' : ICON.ext}</a>` : ''}
              <a class="cal-btn cal-btn--ghost cal-btn--sm" href="${esc(g.href)}" target="_blank" rel="noopener">${ICON.cal}${esc(L.addGoogle)}</a>
              <a class="cal-btn cal-btn--ghost cal-btn--sm" href="${blobUrl}" download="${esc(slug)}.ics">${esc(L.addIcs)}</a>
            </div>
            ${ev.src ? `<p class="cal-dlg__src">${esc(L.via)} ${ev.srcUrl ? `<a href="${esc(ev.srcUrl)}" target="_blank" rel="noopener nofollow">${esc(ev.src)}</a>` : esc(ev.src)}</p>` : ''}
          </div>`;
        lastFocus = document.activeElement;
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        document.documentElement.style.overflow = 'hidden';
        dlgInner.querySelector('[data-cal-close]').focus();
      };
      const close = () => { if (dlg.open) dlg.close(); };
      dlg.addEventListener('close', () => { document.documentElement.style.overflow = ''; lastFocus?.focus?.(); });
      dlg.addEventListener('click', (e) => { if (e.target === dlg || e.target.closest('[data-cal-close]')) close(); });

      /* ---------- events ---------- */
      root.addEventListener('click', (e) => {
        const t = e.target.closest('button, a');
        if (!t || !root.contains(t)) return;
        if (t.dataset.calOpen != null) return open(rendered[+t.dataset.calOpen]);
        if (t.dataset.calHost) { state.host = t.dataset.calHost; return render(); }
        if (t.dataset.calView) { state.view = t.dataset.calView; try { localStorage.setItem('jttp-cal-view', state.view); } catch (err) {} return render(); }
        if (t.hasAttribute('data-cal-more')) { state.shown += listDays; return render(); }
        if (t.dataset.calMonth) {
          if (t.dataset.calMonth === 'today') { state.month = today.slice(0, 7); state.day = today; }
          else { const d = kd(state.month + '-15'); d.setUTCMonth(d.getUTCMonth() + +t.dataset.calMonth); state.month = dk(d).slice(0, 7); state.day = state.month === today.slice(0, 7) ? today : state.month + '-01'; }
          return render();
        }
        if (t.dataset.calDay) {
          state.day = t.dataset.calDay;
          if (state.day.slice(0, 7) !== state.month) state.month = state.day.slice(0, 7);
          render();
          const dv = root.querySelector('.cal-dayview');
          if (dv && dv.firstElementChild && matchMedia('(max-width: 799px)').matches) dv.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
      catSel?.addEventListener('change', () => { state.cat = catSel.value; render(); });

      render();
      if (deepDay) root.querySelector('.cal-dayview')?.scrollIntoView({ block: 'start' });
    };

    const boot = () => document.querySelectorAll('[data-jttp-cal]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-jttp-cal]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jttp-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
    const fmt = (min) => { let h = Math.floor(min / 60); const m = min % 60; const ap = h >= 12 ? 'pm' : 'am'; h = h % 12 || 12; return `${h}${m ? ':' + String(m).padStart(2, '0') : ''}${ap}`; };
    const init = (root) => {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = '1';
      root.classList.add('has-js');
      requestAnimationFrame(() => root.classList.add('is-ready'));
      const $ = (s) => root.querySelector(s);
      const $$ = (s) => [...root.querySelectorAll(s)];

      /* hours → open now? (Pacific time) */
      const hours = {};
      (root.dataset.hours || '').split(/\n/).forEach((line) => {
        const [day, span] = line.split('=').map((x) => (x || '').trim());
        if (!day) return;
        const key = day.toLowerCase().slice(0, 3);
        const m = (span || '').match(/(\d{1,2}):?(\d{2})?\s*-\s*(\d{1,2}):?(\d{2})?/);
        hours[key] = m ? [(+m[1]) * 60 + (+(m[2] || 0)), (+m[3]) * 60 + (+(m[4] || 0))] : null;
      });
      let now;
      try {
        const parts = Object.fromEntries(new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date()).map((p) => [p.type, p.value]));
        now = { day: DAYS.indexOf(parts.weekday.toLowerCase().slice(0, 3)), min: (+parts.hour) * 60 + (+parts.minute) };
      } catch { const d = new Date(); now = { day: d.getDay(), min: d.getHours() * 60 + d.getMinutes() }; }
      const today = DAYS[now.day];
      $$('[data-hours-list] .ct-hours__row').forEach((r) => r.classList.toggle('is-today', r.dataset.day === today));
      const status = $('[data-status]');
      if (status && Object.keys(hours).length) {
        const t = hours[today];
        let text, open = false;
        if (t && now.min >= t[0] && now.min < t[1]) { open = true; text = root.dataset.tOpen.replace('[time]', fmt(t[1])); }
        else {
          // next opening: later today, or the next day with hours
          let label = '', at = null;
          if (t && now.min < t[0]) { label = ''; at = t[0]; }
          else for (let i = 1; i <= 7; i++) { const k = DAYS[(now.day + i) % 7]; if (hours[k]) { label = i === 1 ? 'tomorrow' : k.charAt(0).toUpperCase() + k.slice(1); at = hours[k][0]; break; } }
          text = at == null ? root.dataset.tClosed.replace(/\s*·?\s*\[when\]/, '') : root.dataset.tClosed.replace('[when]', `${label ? label + ' ' : ''}${fmt(at)}`.trim());
        }
        $('[data-status-text]').textContent = text;
        status.classList.toggle('is-open', open);
        status.hidden = false;
      }

      /* route cards without a link pick the form topic and scroll to the form */
      const select = $('[data-topic-select]');
      const form = $('.ct-form');
      $$('[data-topic]').forEach((b) => b.addEventListener('click', () => {
        if (select) { const opt = [...select.options].find((o) => o.value.toLowerCase() === b.dataset.topic.toLowerCase()); if (opt) select.value = opt.value; }
        $('.ct-form-card').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (form && !reduce) { form.classList.remove('is-flash'); void form.offsetWidth; form.classList.add('is-flash'); }
        setTimeout(() => $('.ct-form [name="contact[name]"]')?.focus({ preventScroll: true }), reduce ? 0 : 500);
      }));
      $$('[data-jump]').forEach((a) => a.addEventListener('click', (e) => { const t = $(a.getAttribute('href')); if (!t) return; e.preventDefault(); t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }));
      const done = $('[data-done]');
      if (done) { done.closest('.ct-form-card').scrollIntoView({ block: 'center' }); done.focus({ preventScroll: true }); }

      const io = 'IntersectionObserver' in window && !reduce ? new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' }) : null;
      $$('.ct-reveal').forEach((el) => (io ? io.observe(el) : el.classList.add('is-in')));
    };
    const boot = () => document.querySelectorAll('.jttp-ct').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('.jttp-ct')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jttp-event-venue"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.evReady) return;
      root.dataset.evReady = '1';
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* lightbox */
      const lb = root.querySelector('.ev-lb');
      if (lb) {
        const slides = [...lb.querySelectorAll('.ev-slide')];
        const thumbs = [...lb.querySelectorAll('[data-ev-thumb]')];
        const count = lb.querySelector('[data-ev-count]');
        let i = 0;
        const show = (n) => {
          i = (n + slides.length) % slides.length;
          slides.forEach((s, k) => { s.hidden = k !== i; });
          thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
          if (count) count.textContent = `${i + 1} / ${slides.length}`;
          const t = thumbs[i];
          if (t) t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.clientWidth / 2 + t.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
          // warm the neighbours so arrowing feels instant
          [i - 1, i + 1].forEach((k) => { const img = slides[(k + slides.length) % slides.length]?.querySelector('img'); if (img) img.loading = 'eager'; });
        };
        root.querySelectorAll('[data-ev-open]').forEach((b) => b.addEventListener('click', () => {
          show(+b.dataset.evOpen || 0);
          lb.showModal();
          document.documentElement.style.overflow = 'hidden';
        }));
        lb.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
        lb.querySelector('[data-ev-close]')?.addEventListener('click', () => lb.close());
        lb.querySelector('[data-ev-prev]')?.addEventListener('click', () => show(i - 1));
        lb.querySelector('[data-ev-next]')?.addEventListener('click', () => show(i + 1));
        thumbs.forEach((t) => t.addEventListener('click', () => show(+t.dataset.evThumb)));
        lb.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); show(i - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); show(i + 1); }
        });
        const stage = lb.querySelector('[data-ev-stage]');
        let x0 = null;
        stage.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
        stage.addEventListener('pointerup', (e) => {
          if (x0 === null) return;
          const dx = e.clientX - x0; x0 = null;
          if (Math.abs(dx) > 40 && slides.length > 1) show(i + (dx < 0 ? 1 : -1));
          else if (e.target === stage) lb.close();
        });
      }

      /* share */
      const share = root.querySelector('[data-ev-share]');
      if (share) share.addEventListener('click', async () => {
        const data = { title: document.title, url: location.href.split('#')[0] };
        try {
          if (navigator.share) return await navigator.share(data);
          await navigator.clipboard.writeText(data.url);
          const label = share.querySelector('span'); const was = label.textContent;
          label.textContent = share.dataset.copied;
          setTimeout(() => { label.textContent = was; }, 2000);
        } catch (_) { /* dismissed */ }
      });

      /* Request Pricing → bring the form into view and focus the first field */
      const card = root.querySelector('.ev-card');
      root.querySelectorAll('[data-ev-cta]').forEach((a) => a.addEventListener('click', (e) => {
        if (!card) return;
        e.preventDefault();
        card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        const first = card.querySelector('input:not([type=hidden]), select, textarea');
        if (first) setTimeout(() => first.focus({ preventScroll: true }), reduce ? 0 : 450);
      }));

      /* no past dates */
      const d = new Date(); d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
      root.querySelectorAll('[data-ev-date]').forEach((el) => { el.min = d.toISOString().slice(0, 10); });

      /* after a successful post, land on the thank-you */
      const ok = root.querySelector('[data-ev-success]');
      if (ok) { ok.scrollIntoView({ block: 'center' }); ok.focus({ preventScroll: true }); }

      /* mobile bar: visible once the header button scrolls away, hidden while the form is on screen */
      const bar = root.querySelector('[data-ev-mbar]');
      const head = root.querySelector('[data-ev-head-cta]');
      if (bar && head && card && 'IntersectionObserver' in window) {
        let headGone = false, cardSeen = false;
        const sync = () => {
          const on = headGone && !cardSeen;
          bar.classList.toggle('is-on', on);
          bar.setAttribute('aria-hidden', on ? 'false' : 'true');
          bar.querySelector('[data-ev-cta]').tabIndex = on ? 0 : -1;
        };
        new IntersectionObserver(([en]) => { headGone = !en.isIntersecting && en.boundingClientRect.top < 0; sync(); }).observe(head);
        new IntersectionObserver(([en]) => { cardSeen = en.isIntersecting; sync(); }, { rootMargin: '0px 0px -20% 0px' }).observe(card);
      }
    };
    const boot = () => document.querySelectorAll('[data-jttp-ev]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jttp-events-strip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DAY = 864e5;
    const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const safeUrl = (u) => {
      u = String(u || '').trim();
      const t = u.replace(/[\x00-\x20]/g, '');
      return /^[a-z][a-z0-9+.-]*:/i.test(t) && !/^https?:/i.test(t) ? '' : u;
    };
    const ICON = {
      clock: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.5 2"/></svg>',
      pin: '<svg viewBox="0 0 24 24"><path d="M12 21s-7-6.2-7-11.5a7 7 0 0 1 14 0C19 14.8 12 21 12 21z"/><circle cx="12" cy="9.5" r="2.5"/></svg>',
      repeat: '<svg viewBox="0 0 24 24"><path d="M17 2l3 3-3 3"/><path d="M4 11V9a4 4 0 0 1 4-4h12M7 22l-3-3 3-3"/><path d="M20 13v2a4 4 0 0 1-4 4H4"/></svg>',
    };
    const kd = (k) => new Date(k + 'T12:00:00Z');
    const dk = (d) => d.toISOString().slice(0, 10);
    const addDays = (k, n) => dk(new Date(kd(k).getTime() + n * DAY));
    const fmt = (k, o) => kd(k).toLocaleDateString('en-US', { timeZone: 'UTC', ...o });
    const timeLabel = (m) => { const h = Math.floor(m / 60), mm = m % 60, ap = h >= 12 ? 'pm' : 'am', h12 = h % 12 || 12; return mm ? `${h12}:${String(mm).padStart(2, '0')}${ap}` : `${h12}${ap}`; };
    const hhmm = (s) => { const m = /^(\d{1,2}):?(\d{2})?\s*(am|pm)?$/i.exec(String(s || '').trim()); if (!m) return null; let h = +m[1]; const ap = (m[3] || '').toLowerCase(); if (ap === 'pm' && h < 12) h += 12; if (ap === 'am' && h === 12) h = 0; return h * 60 + (+m[2] || 0); };

    // Weekly events live in the calendar section on the calendar page; read them from there (cached 10 min).
    const weeklyFrom = async (url) => {
      const key = 'jttp-evs-weekly:' + url;
      try { const c = JSON.parse(sessionStorage.getItem(key) || 'null'); if (c && Date.now() - c.t < 6e5) return c.d; } catch (e) {}
      try {
        const ctl = new AbortController(); const timer = setTimeout(() => ctl.abort(), 4000);
        const html = await (await fetch(url, { signal: ctl.signal, credentials: 'same-origin' })).text();
        clearTimeout(timer);
        const el = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cal-recurring]');
        const d = el ? JSON.parse(el.textContent) : [];
        try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), d })); } catch (e) {}
        return d;
      } catch (e) { return []; }
    };

    const init = async (root) => {
      if (root.dataset.evsReady) return;
      root.dataset.evsReady = '1';
      const list = root.querySelector('[data-evs-list]');
      const note = root.querySelector('[data-evs-note]');
      const read = (sel, fb) => { try { return JSON.parse(root.querySelector(sel)?.textContent || ''); } catch (e) { return fb; } };
      const L = read('[data-evs-labels]', {});
      const tz = root.dataset.tz || 'America/Los_Angeles';
      const mode = root.dataset.mode === 'today' ? 'today' : 'upcoming';
      const days = Math.max(1, +root.dataset.days || 7);
      const limit = Math.max(1, +root.dataset.limit || 8);
      const show = root.dataset.show || 'all';
      const images = root.dataset.images !== 'false';
      const calUrl = safeUrl(root.dataset.calUrl) || '/pages/upcoming-events';

      const pf = new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
      const where = (d) => { const o = {}; pf.formatToParts(d).forEach((p) => { o[p.type] = p.value; }); return { key: `${o.year}-${o.month}-${o.day}`, min: (+o.hour % 24) * 60 + +o.minute }; };
      const parseDate = (s) => { if (!s) return null; const d = new Date(String(s).replace(/([+-]\d{2})(\d{2})$/, '$1:$2').replace(' ', 'T')); return isNaN(d) ? null : d; };
      const now = where(new Date());
      const today = now.key;
      const horizon = addDays(today, 60);

      /* occurrences { ev, key, min, cont, rec } from today to the 60-day horizon */
      const occ = [];
      read('[data-evs-events]', []).forEach((r) => {
        const s = parseDate(r.start); if (!s || !r.title) return;
        const e = parseDate(r.end);
        const a = where(s), b = e && e > s ? where(e) : null;
        const ev = {
          title: r.title, host: r.host === 'jttp' ? 'jttp' : 'community', cat: r.cat || '', venue: r.venue || '', town: r.town || '',
          desc: r.desc || '', url: safeUrl(r.url), img: safeUrl(r.img), allDay: !!r.allDay,
          startKey: a.key, endKey: b ? (r.allDay || b.min > 0 ? b.key : addDays(b.key, -1)) : a.key,
          startMin: r.allDay ? null : a.min, endMin: b && !r.allDay ? b.min : null,
        };
        for (let k = ev.startKey, n = 0; k <= ev.endKey && n < 62; k = addDays(k, 1), n++) {
          if (k >= today && k <= horizon) occ.push({ ev, key: k, min: k === ev.startKey ? (ev.startMin ?? -1) : -1, cont: k !== ev.startKey });
        }
      });
      if (root.dataset.weekly === 'true') {
        (await weeklyFrom(calUrl)).forEach((r) => {
          const dlist = String(r.days || '').split(',').filter(Boolean).map(Number);
          if (!r.title || !dlist.length) return;
          const sm = hhmm(r.startTime), em = hhmm(r.endTime);
          const skip = new Set(String(r.skip || '').split(/[\s,]+/).filter(Boolean));
          const names = [...dlist].sort((x, y) => ((x + 6) % 7) - ((y + 6) % 7)).map((d) => fmt(addDays('2026-01-04', d), { weekday: 'short' }));
          const ev = {
            title: r.title, host: r.host === 'community' ? 'community' : 'jttp', cat: r.cat || '', venue: r.venue || '', town: '',
            desc: r.desc || '', url: safeUrl(r.url), img: safeUrl(r.img), allDay: sm == null, startMin: sm, endMin: em,
            recurring: `${L.weekly || 'Every'} ${names.join(' & ')}`,
          };
          const from = /^\d{4}-\d{2}-\d{2}$/.test(r.from) && r.from > today ? r.from : today;
          const until = /^\d{4}-\d{2}-\d{2}$/.test(r.until) && r.until < horizon ? r.until : horizon;
          for (let k = from; k <= until; k = addDays(k, 1)) if (dlist.includes(kd(k).getUTCDay()) && !skip.has(k)) occ.push({ ev, key: k, min: sm ?? -1, cont: false, rec: true });
        });
      }
      occ.sort((a, b) => (a.key < b.key ? -1 : a.key > b.key ? 1 : 0) || (a.ev.host === b.ev.host ? 0 : a.ev.host === 'jttp' ? -1 : 1) || a.min - b.min);

      const pass = (o) => (show === 'all' || o.ev.host === show)
        // drop today's events that are already over
        && !(o.key === today && o.ev.endMin != null && (o.ev.endKey === today || o.rec) && o.ev.endMin < now.min);
      const pick = (from, to) => occ.filter((o) => pass(o) && o.key >= from && o.key <= to && (!o.cont || o.key === from));

      let rows = mode === 'today' ? pick(today, today) : pick(today, addDays(today, days - 1));
      if (!rows.length && mode === 'today' && root.dataset.fallback === 'true') {
        const next = occ.find((o) => pass(o) && o.key > today && !o.cont);
        if (next) rows = pick(next.key, addDays(next.key, days - 1));
      }
      const total = rows.length;
      rows = rows.slice(0, limit);

      const place = (ev) => [ev.venue, ev.town].filter(Boolean).join(', ');
      const when = (o) => {
        if (o.ev.allDay || o.min < 0) return L.allDay;
        return timeLabel(o.min) + (o.ev.endMin != null ? `–${timeLabel(o.ev.endMin)}` : '');
      };
      const link = (ev) => ev.url || calUrl;
      const ext = (ev) => (ev.url && /^https?:/i.test(ev.url) && !ev.url.includes(location.host) ? ' target="_blank" rel="noopener nofollow"' : '');
      const jttp = (o) => {
        const ev = o.ev, img = images && ev.img;
        return `<a class="evs-ev evs-ev--jttp${img ? ' has-img' : ''}" href="${esc(link(ev))}"${ext(ev)}>
          ${img ? `<span class="evs-ev__media"><img src="${esc(ev.img)}" alt="" loading="lazy"></span>` : ''}
          <span class="evs-ev__body">
            <span class="evs-badge">${esc(L.jttp)}</span>
            <span class="evs-ev__title">${esc(ev.title)}</span>
            <span class="evs-meta">
              <span>${ICON.clock}${esc(when(o))}</span>
              ${place(ev) ? `<span>${ICON.pin}${esc(place(ev))}</span>` : ''}
              ${ev.recurring ? `<span>${ICON.repeat}${esc(ev.recurring)}</span>` : ''}
            </span>
            ${ev.desc ? `<span class="evs-desc">${esc(ev.desc)}</span>` : ''}
          </span>
        </a>`;
      };
      const com = (o) => {
        const ev = o.ev;
        return `<a class="evs-ev evs-ev--com" href="${esc(link(ev))}"${ext(ev)}>
          <span class="evs-time">${esc(ev.allDay || o.min < 0 ? L.allDay : timeLabel(o.min))}</span>
          <span><span class="evs-ev__title">${esc(ev.title)}</span>${place(ev) ? `<span class="evs-sub">${esc(place(ev))}</span>` : ''}</span>
          ${ev.cat ? `<span class="evs-tag">${esc(ev.cat)}</span>` : ''}
        </a>`;
      };

      if (!rows.length) {
        list.innerHTML = `<p class="evs-empty">${esc(L.empty)}</p>`;
        return;
      }
      const groups = new Map();
      rows.forEach((o) => { if (!groups.has(o.key)) groups.set(o.key, []); groups.get(o.key).push(o); });
      const rel = (k) => (k === today ? L.today : k === addDays(today, 1) ? L.tomorrow : '');
      list.innerHTML = [...groups].map(([k, l]) => `
        <section class="evs-day" aria-label="${esc(fmt(k, { weekday: 'long', month: 'long', day: 'numeric' }))}">
          <div class="evs-day__label">
            <span class="evs-day__dow">${esc(fmt(k, { weekday: 'long' }))}</span>
            <span class="evs-day__date">${esc(fmt(k, { month: 'short', day: 'numeric' }))}</span>
            ${rel(k) ? `<span class="evs-day__rel">${esc(rel(k))}</span>` : ''}
          </div>
          <div class="evs-items">${l.map((o) => (o.ev.host === 'jttp' ? jttp(o) : com(o))).join('')}</div>
        </section>`).join('')
        + (total > rows.length && L.more ? `<a class="evs-more" href="${esc(calUrl)}">${esc(L.more.replace('[count]', total - rows.length))}</a>` : '');
      if (note && rows.some((o) => o.ev.host !== 'jttp')) note.hidden = false;
    };

    const boot = () => document.querySelectorAll('[data-jttp-evs]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-jttp-evs]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jttp-field-guide-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // "/" jumps to the field guide search, unless the page already has its own (the field guide).
    document.addEventListener('keydown', (e) => {
      if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey || document.querySelector('[data-jttp-fg]')) return;
      const a = document.activeElement;
      if (a && (a.isContentEditable || /^(input|textarea|select)$/i.test(a.tagName))) return;
      const q = document.querySelector('[data-fh-q]');
      if (!q) return;
      e.preventDefault();
      q.focus({ preventScroll: true });
      q.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jttp-field-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const norm = (s) => String(s ?? '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/['’]/g, '');
    const STOP = new Set(['a', 'an', 'and', 'the', 'of', 'in', 'to', 'for', 'on', 'at', 'is', 'it', 'with', 'what', 'where', 'how', 'best', 'do', 'near', 'jt', 'joshua', 'tree']);
    // A few ways visitors ask for the same thing.
    const SYN = {
      hike: ['trail', 'hiking', 'walk'], hikes: ['trail', 'hiking'], hiking: ['hike', 'trail'], trail: ['hike'],
      stars: ['stargazing', 'meteor', 'night sky', 'dark sky', 'perseid'], stargazing: ['stars', 'meteor', 'night sky'],
      food: ['eat', 'restaurant', 'recipe', 'dinner', 'cook'], eat: ['restaurant', 'food', 'dinner'], restaurants: ['eat', 'food'],
      flowers: ['wildflower', 'bloom'], wildflowers: ['bloom', 'flower'], bloom: ['wildflower'],
      shop: ['shopping', 'souvenir', 'vendor', 'market'], shopping: ['shop', 'souvenir', 'market'], gifts: ['gift', 'souvenir'],
      park: ['national park'], jtnp: ['national park'], climbing: ['climb', 'boulder'], climb: ['climbing', 'boulder'],
      heat: ['summer', 'hot'], hot: ['summer', 'heat'], kids: ['kid', 'family', 'little'], music: ['concert', 'festival', 'sound'],
      art: ['gallery', 'artist', 'museum', 'studio'], outfit: ['wear', 'style', 'dress'], wear: ['style', 'dress', 'outfit'],
      '29': ['twentynine'], 'twentynine': ['29'],
    };

    class FieldGuide {
      constructor(root) {
        this.root = root;
        this.q = root.querySelector('[data-fg-q]');
        this.form = root.querySelector('[data-fg-form]');
        this.results = root.querySelector('[data-fg-results]');
        this.grid = root.querySelector('[data-fg-grid]');
        this.count = root.querySelector('[data-fg-count]');
        this.empty = root.querySelector('[data-fg-empty]');
        this.browse = [...root.querySelectorAll('[data-fg-browse]')];
        this.shelves = root.querySelector('[data-fg-shelves]');
        this.topicSel = root.querySelector('[data-fg-topic-select]');
        this.sortSel = root.querySelector('[data-fg-sort]');
        this.bar = root.querySelector('[data-fg-bar]');
        this.shelfN = parseInt(root.dataset.shelf, 10) || 4;

        let index = {};
        try { index = JSON.parse(root.querySelector('[data-fg-index]').textContent); } catch (e) {}

        this.guideLabels = {};
        root.querySelectorAll('[data-fg-guide]').forEach((b) => { this.guideLabels[b.dataset.fgGuide] = b.firstChild.textContent.trim(); });
        this.topicLabels = {};
        if (this.topicSel) [...this.topicSel.options].forEach((o) => { if (o.value) this.topicLabels[o.value] = o.textContent; });

        this.items = [...root.querySelectorAll('.fg-shelf [data-fg-card]')].map((el) => {
          const title = el.querySelector('.fg-card__title a').textContent;
          const topics = (el.dataset.topics || '').split(/\s+/).filter(Boolean);
          const guide = el.dataset.guide;
          return {
            el, guide, topics, title,
            date: el.dataset.date || '',
            t: norm(title),
            meta: norm([this.guideLabels[guide], ...topics.map((x) => this.topicLabels[x] || x)].join(' ')),
            body: norm(el.querySelector('.fg-card__exc')?.textContent + ' ' + (index[el.dataset.fgCard] || '')),
          };
        });

        this.state = { q: '', guide: '', topic: '', sort: 'best' };
        this.row = root.querySelector('.fg-seg');
        this.fade = () => {
          const r = this.row;
          r.classList.toggle('has-l', r.scrollLeft > 2);
          r.classList.toggle('has-r', r.scrollLeft + r.clientWidth < r.scrollWidth - 2);
        };
        this.row.addEventListener('scroll', this.fade, { passive: true });
        window.addEventListener('resize', this.fade);
        this.markNew();
        this.collapseShelves();
        this.countTopics();
        this.bind();
        this.readUrl();
        this.render(false);
      }

      markNew() {
        const cutoff = Date.now() - 21 * 864e5;
        this.items.forEach((it) => {
          if (it.date && new Date(it.date + 'T12:00:00').getTime() > cutoff) {
            const k = it.el.querySelector('.fg-kicker');
            if (k && !k.querySelector('.fg-new')) k.insertAdjacentHTML('beforeend', '<span class="fg-new">New</span>');
          }
        });
      }

      // Show whole rows only: round the per-guide count to the number of columns on screen.
      fitShelves() {
        this.root.querySelectorAll('[data-fg-shelf]').forEach((shelf) => {
          const grid = shelf.querySelector('.fg-grid');
          const cards = grid.querySelectorAll(':scope > .fg-card');
          const cols = Math.max(1, getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length);
          const show = cols === 1 ? this.shelfN : Math.max(cols, Math.round(this.shelfN / cols) * cols);
          cards.forEach((c, i) => c.classList.toggle('is-extra', i >= show));
          const wrap = shelf.querySelector('[data-fg-expand-wrap]');
          if (wrap) wrap.hidden = cards.length <= show;
        });
      }

      collapseShelves() {
        this.fitShelves();
        let w = window.innerWidth;
        window.addEventListener('resize', () => { if (window.innerWidth !== w) { w = window.innerWidth; this.fitShelves(); } });
        this.root.querySelectorAll('[data-fg-shelf]').forEach((shelf) => {
          const wrap = shelf.querySelector('[data-fg-expand-wrap]');
          if (!wrap) return;
          const btn = wrap.querySelector('[data-fg-expand]');
          const label = btn.textContent;
          btn.addEventListener('click', () => {
            const open = shelf.classList.toggle('is-open');
            btn.setAttribute('aria-expanded', open);
            btn.textContent = open ? 'Show fewer' : label;
            if (!open) shelf.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        });
      }

      countTopics() {
        const n = {};
        this.items.forEach((it) => it.topics.forEach((t) => { n[t] = (n[t] || 0) + 1; }));
        this.root.querySelectorAll('.fg-topic[data-fg-topic]').forEach((b) => {
          const c = n[b.dataset.fgTopic] || 0;
          b.classList.toggle('is-empty', !c);
          const s = b.querySelector('[data-fg-tcount]');
          if (s) s.textContent = c;
        });
        if (this.topicSel) {
          [...this.topicSel.options].forEach((o) => { if (o.value && !n[o.value]) o.remove(); });
          this.topicSel.querySelectorAll('optgroup').forEach((g) => { if (!g.children.length) g.remove(); });
          // Nothing to pick: drop the dropdown instead of showing an empty one.
          if (this.topicSel.options.length < 2) { this.topicSel.closest('[data-fg-topic-wrap]')?.remove(); this.topicSel = null; }
        }
        this.topicCounts = n;
      }

      bind() {
        let t;
        this.q.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => this.set({ q: this.q.value }), 140); });
        this.form.addEventListener('submit', (e) => { e.preventDefault(); this.q.blur(); this.set({ q: this.q.value }, true); });
        this.q.addEventListener('keydown', (e) => { if (e.key === 'Escape') { this.q.value = ''; this.set({ q: '' }); } });
        document.addEventListener('keydown', (e) => {
          if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
          const a = document.activeElement;
          if (a && (a.isContentEditable || /^(input|textarea|select)$/i.test(a.tagName))) return;
          e.preventDefault();
          this.q.focus();
        });
        this.root.addEventListener('click', (e) => {
          const g = e.target.closest('[data-fg-guide]');
          if (g) return this.set({ guide: g.dataset.fgGuide }, true);
          const tp = e.target.closest('[data-fg-topic]');
          if (tp) return this.set({ topic: tp.dataset.fgTopic }, true);
          if (e.target.closest('[data-fg-clear]')) { this.q.value = ''; return this.set({ q: '', guide: '', topic: '' }, true); }
        });
        this.topicSel?.addEventListener('change', () => this.set({ topic: this.topicSel.value }, true));
        this.sortSel?.addEventListener('change', () => this.set({ sort: this.sortSel.value }));
        window.addEventListener('popstate', () => { this.readUrl(); this.render(false); });
      }

      readUrl() {
        const p = new URLSearchParams(location.search);
        this.state.q = p.get('q') || '';
        this.state.guide = p.get('guide') || '';
        this.state.topic = p.get('topic') || '';
        if (this.state.topic && !this.topicLabels[this.state.topic]) {
          this.state.q = this.state.q || this.state.topic.replace(/-/g, ' ');
          this.state.topic = '';
        }
        this.state.sort = p.get('sort') || 'best';
        this.q.value = this.state.q;
        if (!p.get('q') && this.state.q) this.set({}, false);
      }

      set(patch, jump) {
        Object.assign(this.state, patch);
        const p = new URLSearchParams(location.search);
        ['q', 'guide', 'topic'].forEach((k) => (this.state[k] ? p.set(k, this.state[k].trim()) : p.delete(k)));
        this.state.sort !== 'best' ? p.set('sort', this.state.sort) : p.delete('sort');
        const qs = p.toString();
        history.replaceState(null, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
        this.render(jump);
      }

      terms(q) {
        return norm(q).split(/[^a-z0-9]+/).filter((w) => w && (w.length > 1 || /\d/.test(w)) && !STOP.has(w));
      }

      score(it, terms) {
        let s = 0;
        for (const w of terms) {
          const alts = [w, ...(SYN[w] || [])];
          let best = 0;
          for (const a of alts) {
            const re = new RegExp('(^|[^a-z0-9])' + a.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
            const k = a === w ? 1 : 0.6;
            if (re.test(it.t)) best = Math.max(best, 6 * k);
            else if (re.test(it.meta)) best = Math.max(best, 4 * k);
            else if (re.test(it.body)) best = Math.max(best, 1.5 * k);
          }
          if (!best) return 0; // every word has to match somewhere
          s += best;
        }
        // newer notes win ties
        return s + (it.date ? parseInt(it.date.replace(/-/g, ''), 10) / 1e10 : 0);
      }

      render(jump) {
        const { q, guide, topic, sort } = this.state;
        const terms = this.terms(q);
        const active = !!(terms.length || guide || topic);

        this.root.querySelectorAll('[data-fg-guide]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.fgGuide === guide)));
        const on = this.row.querySelector('[aria-pressed="true"]');
        if (on && (on.offsetLeft < this.row.scrollLeft || on.offsetLeft + on.offsetWidth > this.row.scrollLeft + this.row.clientWidth)) {
          this.row.scrollTo({ left: on.offsetLeft - 24, behavior: jump ? 'smooth' : 'auto' });
        }
        this.fade();
        if (this.topicSel) { this.topicSel.value = topic; this.topicSel.classList.toggle('is-set', !!topic); }
        if (this.sortSel) this.sortSel.value = sort;

        this.results.hidden = !active;
        this.browse.forEach((b) => (b.hidden = active));
        this.shelves.hidden = active;
        if (!active) { this.grid.replaceChildren(); this.fitShelves(); return; }

        let list = this.items
          .filter((it) => (!guide || it.guide === guide) && (!topic || it.topics.includes(topic)))
          .map((it) => ({ it, s: terms.length ? this.score(it, terms) : 1 }))
          .filter((r) => r.s > 0);

        const by = sort === 'best' && !terms.length ? 'new' : sort;
        list.sort((a, b) =>
          by === 'az' ? a.it.title.localeCompare(b.it.title)
          : by === 'old' ? a.it.date.localeCompare(b.it.date)
          : by === 'new' ? b.it.date.localeCompare(a.it.date)
          : b.s - a.s);

        const hl = terms.length ? new RegExp('(^|[^\\p{L}\\p{N}])(' + terms.map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|') + ')', 'giu') : null;
        this.grid.replaceChildren(...list.map(({ it }) => {
          const c = it.el.cloneNode(true);
          c.classList.remove('is-extra');
          if (hl) { const a = c.querySelector('.fg-card__title a'); a.innerHTML = esc(a.textContent).replace(hl, '$1<mark>$2</mark>'); }
          return c;
        }));

        const parts = [];
        if (guide) parts.push(esc(this.guideLabels[guide] || guide));
        if (topic) parts.push(esc(this.topicLabels[topic] || topic));
        const where = parts.length ? ' in ' + parts.join(' · ') : '';
        const n = list.length;
        this.count.innerHTML = terms.length
          ? `${n} field note${n === 1 ? '' : 's'} for <em>“${esc(q.trim())}”</em>${where}`
          : `${n} field note${n === 1 ? '' : 's'}${where}`;
        this.empty.hidden = n > 0;
        if (!n) {
          const tryEl = this.empty.querySelector('[data-fg-empty-try]');
          const top = Object.entries(this.topicCounts).sort((a, b) => b[1] - a[1]).slice(0, 5);
          tryEl.replaceChildren(...top.map(([slug]) => {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'fg-pill';
            b.dataset.fgTopic = slug;
            b.textContent = this.topicLabels[slug] || slug;
            return b;
          }));
        }
        if (jump) {
          const top = this.bar.getBoundingClientRect().top;
          if (top < 0 || top > window.innerHeight * 0.6) this.bar.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }

    const init = (scope) => (scope || document).querySelectorAll('[data-jttp-fg]').forEach((el) => {
      if (el.__fg) return;
      el.__fg = new FieldGuide(el);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
    else init();
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jttp-field-note"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const slug = (s) => s.toLowerCase().replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 'section';

    const init = (root) => {
      if (root.__fa) return;
      root.__fa = true;
      const prose = root.querySelector('[data-fa-prose]');

      // Lead paragraph: skip short notes at the top ("Updated Monday…", an all-italic editor's note) and empty ones.
      const isNote = (p) => {
        const text = p.textContent.trim();
        if (!text) return true;
        const kids = [...p.childNodes].filter((n) => n.nodeType === 1 || n.textContent.trim());
        const allItalic = kids.length === 1 && kids[0].nodeType === 1 && /^(EM|I|SMALL)$/.test(kids[0].tagName);
        return allItalic || (text.length < 90 && /^(updated|last updated|editor|note|photo)/i.test(text));
      };
      for (const el of prose.children) {
        if (el.tagName !== 'P') break;
        if (isNote(el)) { if (el.textContent.trim()) el.classList.add('fa-dateline'); continue; }
        el.classList.add('fa-lead');
        break;
      }

      // "New" next to the date for the first three weeks
      const t = root.querySelector('[data-fa-date]');
      if (t && Date.now() - new Date(t.getAttribute('datetime') + 'T12:00:00').getTime() < 21 * 864e5) {
        t.insertAdjacentHTML('afterend', '<span class="fa-new">New</span>');
      }

      // Contents from the H2s (only worth it with three or more)
      const heads = [...prose.querySelectorAll('h2')].filter((h) => h.textContent.trim());
      if (heads.length >= 3) {
        const used = new Set();
        heads.forEach((h) => {
          if (!h.id) { let id = slug(h.textContent); while (used.has(id) || document.getElementById(id)) id += '-2'; h.id = id; }
          used.add(h.id);
        });
        root.querySelectorAll('[data-fa-toc-list]').forEach((ol) => {
          ol.innerHTML = '';
          heads.forEach((h) => {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = '#' + h.id;
            a.textContent = h.textContent.trim();
            li.append(a);
            ol.append(li);
          });
        });
        root.querySelector('[data-fa-toc]').hidden = false;
        const m = root.querySelector('[data-fa-toc-m]');
        m.hidden = false;
        m.addEventListener('click', (e) => { if (e.target.closest('a')) m.open = false; });

        const links = [...root.querySelectorAll('[data-fa-toc] a')];
        const spy = () => {
          let cur = 0;
          heads.forEach((h, i) => { if (h.getBoundingClientRect().top < 140) cur = i; });
          links.forEach((a, i) => a.setAttribute('aria-current', String(i === cur)));
        };
        spy();
        window.addEventListener('scroll', spy, { passive: true });
      }

      // Reading progress across the article body
      const bar = root.querySelector('[data-fa-progress]');
      const prog = () => {
        const r = prose.getBoundingClientRect();
        const p = Math.min(1, Math.max(0, (window.innerHeight * 0.5 - r.top) / r.height));
        bar.style.transform = `scaleX(${p})`;
      };
      prog();
      window.addEventListener('scroll', prog, { passive: true });
      window.addEventListener('resize', prog);

      // Share: native sheet on phones, copy link elsewhere
      const share = root.querySelector('[data-fa-share]');
      share?.addEventListener('click', async () => {
        const url = location.href.split('#')[0];
        const title = root.querySelector('.fa-title')?.textContent.trim();
        if (navigator.share && matchMedia('(pointer: coarse)').matches) {
          try { await navigator.share({ title, url }); } catch (e) {}
          return;
        }
        const label = share.querySelector('span');
        try { await navigator.clipboard.writeText(url); label.textContent = 'Link copied'; }
        catch (e) { label.textContent = 'Copy failed'; }
        setTimeout(() => { label.textContent = 'Share'; }, 2000);
      });
    };

    const run = (scope) => (scope || document).querySelectorAll('[data-jttp-fa]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run());
    else run();
    document.addEventListener('shopify:section:load', (e) => run(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jttp-guide-blog"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const norm = (s) => String(s ?? '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/['’]/g, '');
    const STOP = new Set(['a', 'an', 'and', 'the', 'of', 'in', 'to', 'for', 'on', 'at', 'is', 'it', 'with', 'what', 'where', 'how', 'best', 'do', 'near', 'jt', 'joshua', 'tree']);
    const slug = (s) => norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

    const init = (root) => {
      if (root.__fb) return;
      root.__fb = true;
      // Single-line chip row: fade the edges that have more, and show the current chip.
      const row = root.querySelector('.fb-guides');
      if (row) {
        const fade = () => {
          row.classList.toggle('has-l', row.scrollLeft > 2);
          row.classList.toggle('has-r', row.scrollLeft + row.clientWidth < row.scrollWidth - 2);
        };
        const cur = row.querySelector('[aria-current="page"], [aria-pressed="true"]');
        if (cur && cur.offsetLeft + cur.offsetWidth > row.clientWidth) row.scrollLeft = cur.offsetLeft - 24;
        fade();
        row.addEventListener('scroll', fade, { passive: true });
        window.addEventListener('resize', fade);
      }
      const q = root.querySelector('[data-fb-q]');
      const form = root.querySelector('[data-fb-form]');
      const count = root.querySelector('[data-fb-count]');
      const empty = root.querySelector('[data-fb-empty]');
      const everywhere = root.querySelector('[data-fb-everywhere]');
      const items = [...root.querySelectorAll('[data-fb-card]')].map((el) => ({
        el,
        a: el.querySelector('.fb-card__title a'),
        title: el.querySelector('.fb-card__title a').textContent,
        text: norm(el.dataset.text + ' ' + el.dataset.topics),
        topics: el.dataset.topics.split('|').filter(Boolean),
      }));

      // New badge
      const cutoff = Date.now() - 21 * 864e5;
      items.forEach((it) => {
        const d = it.el.dataset.date;
        if (d && new Date(d + 'T12:00:00').getTime() > cutoff) it.el.querySelector('.fb-card__meta').insertAdjacentHTML('afterbegin', '<span class="fb-new">New</span>');
      });

      // Topic chips present in this guide, most common first
      const n = {};
      items.forEach((it) => it.topics.forEach((t) => { n[t] = (n[t] || 0) + 1; }));
      const tops = Object.entries(n).filter(([, c]) => c > 1 || items.length < 8).sort((x, y) => y[1] - x[1]).slice(0, 10);
      const wrap = root.querySelector('[data-fb-topics]');
      if (tops.length > 1) {
        root.querySelector('[data-fb-topic-list]').innerHTML = tops.map(([t, c]) => `<button type="button" class="fb-topic" data-t="${esc(t)}" aria-pressed="false">${esc(t)} <span>${c}</span></button>`).join('');
        wrap.hidden = false;
      }

      const p = new URLSearchParams(location.search);
      let topic = tops.find(([t]) => slug(t) === p.get('topic'))?.[0] || '';
      q.value = p.get('q') || '';

      const render = () => {
        const terms = norm(q.value).split(/[^a-z0-9]+/).filter((w) => w && (w.length > 1 || /\d/.test(w)) && !STOP.has(w));
        const active = !!(terms.length || topic);
        root.classList.toggle('is-filtered', active);
        const hl = terms.length ? new RegExp('(^|[^\\p{L}\\p{N}])(' + terms.map((w) => w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|') + ')', 'giu') : null;
        let shown = 0;
        items.forEach((it) => {
          const ok = (!topic || it.topics.includes(topic)) && terms.every((w) => new RegExp('(^|[^a-z0-9])' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).test(it.text));
          it.el.hidden = !ok;
          if (ok) shown++;
          it.a.innerHTML = hl && ok ? esc(it.title).replace(hl, '$1<mark>$2</mark>') : esc(it.title);
        });
        root.querySelectorAll('.fb-topic').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.t === topic)));
        count.hidden = !active;
        if (active) {
          const what = [terms.length ? `for <em>“${esc(q.value.trim())}”</em>` : '', topic ? `in ${esc(topic)}` : ''].filter(Boolean).join(' ');
          count.innerHTML = `${shown} field note${shown === 1 ? '' : 's'} ${what} <button type="button" data-fb-clear>Clear</button>`;
        }
        empty.hidden = shown > 0;
        if (everywhere) everywhere.href = everywhere.getAttribute('href').split('?')[0] + (q.value.trim() ? '?q=' + encodeURIComponent(q.value.trim()) : '');
        const u = new URLSearchParams(location.search);
        q.value.trim() ? u.set('q', q.value.trim()) : u.delete('q');
        topic ? u.set('topic', slug(topic)) : u.delete('topic');
        const qs = u.toString();
        history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
      };

      let t;
      q.addEventListener('input', () => { clearTimeout(t); t = setTimeout(render, 120); });
      q.addEventListener('keydown', (e) => { if (e.key === 'Escape') { q.value = ''; render(); } });
      // Searching here filters this guide; the form only submits to the field guide without JS.
      form.addEventListener('submit', (e) => { e.preventDefault(); render(); });
      root.addEventListener('click', (e) => {
        const b = e.target.closest('.fb-topic');
        if (b) { topic = topic === b.dataset.t ? '' : b.dataset.t; return render(); }
        if (e.target.closest('[data-fb-clear]')) { q.value = ''; topic = ''; render(); }
      });
      if (q.value || topic) render();
    };

    const run = (scope) => (scope || document).querySelectorAll('[data-jttp-fb]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run());
    else run();
    document.addEventListener('shopify:section:load', (e) => run(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jttp-job-posting"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (root.dataset.jbReady) return;
      root.dataset.jbReady = '1';
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* lightbox */
      const lb = root.querySelector('.ev-lb');
      if (lb) {
        const slides = [...lb.querySelectorAll('.ev-slide')];
        const thumbs = [...lb.querySelectorAll('[data-ev-thumb]')];
        const count = lb.querySelector('[data-ev-count]');
        let i = 0;
        const show = (n) => {
          i = (n + slides.length) % slides.length;
          slides.forEach((s, k) => { s.hidden = k !== i; });
          thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
          if (count) count.textContent = `${i + 1} / ${slides.length}`;
          const t = thumbs[i];
          if (t) t.parentElement.scrollTo({ left: t.offsetLeft - t.parentElement.clientWidth / 2 + t.clientWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
          // warm the neighbours so arrowing feels instant
          [i - 1, i + 1].forEach((k) => { const img = slides[(k + slides.length) % slides.length]?.querySelector('img'); if (img) img.loading = 'eager'; });
        };
        root.querySelectorAll('[data-ev-open]').forEach((b) => b.addEventListener('click', () => {
          show(+b.dataset.evOpen || 0);
          lb.showModal();
          document.documentElement.style.overflow = 'hidden';
        }));
        lb.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
        lb.querySelector('[data-ev-close]')?.addEventListener('click', () => lb.close());
        lb.querySelector('[data-ev-prev]')?.addEventListener('click', () => show(i - 1));
        lb.querySelector('[data-ev-next]')?.addEventListener('click', () => show(i + 1));
        thumbs.forEach((t) => t.addEventListener('click', () => show(+t.dataset.evThumb)));
        lb.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); show(i - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); show(i + 1); }
        });
        const stage = lb.querySelector('[data-ev-stage]');
        let x0 = null;
        stage.addEventListener('pointerdown', (e) => { x0 = e.clientX; });
        stage.addEventListener('pointerup', (e) => {
          if (x0 === null) return;
          const dx = e.clientX - x0; x0 = null;
          if (Math.abs(dx) > 40 && slides.length > 1) show(i + (dx < 0 ? 1 : -1));
          else if (e.target === stage) lb.close();
        });
      }

      /* share */
      const share = root.querySelector('[data-ev-share]');
      if (share) share.addEventListener('click', async () => {
        const data = { title: document.title, url: location.href.split('#')[0] };
        try {
          if (navigator.share) return await navigator.share(data);
          await navigator.clipboard.writeText(data.url);
          const label = share.querySelector('span'); const was = label.textContent;
          label.textContent = share.dataset.copied;
          setTimeout(() => { label.textContent = was; }, 2000);
        } catch (_) { /* dismissed */ }
      });

      /* Request Pricing → bring the form into view and focus the first field */
      const card = root.querySelector('.ev-card');
      root.querySelectorAll('[data-ev-cta]').forEach((a) => a.addEventListener('click', (e) => {
        if (!card) return;
        e.preventDefault();
        card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        const first = card.querySelector('input:not([type=hidden]), select, textarea');
        if (first) setTimeout(() => first.focus({ preventScroll: true }), reduce ? 0 : 450);
      }));

      /* no past dates */
      const d = new Date(); d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
      root.querySelectorAll('[data-ev-date]').forEach((el) => { el.min = d.toISOString().slice(0, 10); });

      /* after a successful post, land on the thank-you */
      const ok = root.querySelector('[data-ev-success]');
      if (ok) { ok.scrollIntoView({ block: 'center' }); ok.focus({ preventScroll: true }); }

      /* mobile bar: visible once the header button scrolls away, hidden while the form is on screen */
      const bar = root.querySelector('[data-ev-mbar]');
      const head = root.querySelector('[data-ev-head-cta]');
      if (bar && head && card && 'IntersectionObserver' in window) {
        let headGone = false, cardSeen = false;
        const sync = () => {
          const on = headGone && !cardSeen;
          bar.classList.toggle('is-on', on);
          bar.setAttribute('aria-hidden', on ? 'false' : 'true');
          bar.querySelector('[data-ev-cta]').tabIndex = on ? 0 : -1;
        };
        new IntersectionObserver(([en]) => { headGone = !en.isIntersecting && en.boundingClientRect.top < 0; sync(); }).observe(head);
        new IntersectionObserver(([en]) => { cardSeen = en.isIntersecting; sync(); }, { rootMargin: '0px 0px -20% 0px' }).observe(card);
      }

      /* applications: with a mailer endpoint set, send the whole form (resume attached) there instead of Shopify's contact form */
      const endpoint = root.dataset.jbApply;
      const form = root.querySelector('.ev-form');
      if (endpoint && form && !root.querySelector('[data-ev-success]')) {
        const t = form.querySelector('[data-jb-t]');
        if (t) t.value = String(Date.now());
        const submit = form.querySelector('[type=submit]');
        const box = form.querySelector('[data-jb-file]');
        const MAX = 10 * 1024 * 1024;
        let fail = () => {};
        if (box) {
          const input = box.querySelector('[data-jb-input]');
          const status = box.querySelector('[data-jb-status]');
          const hint = box.querySelector('[data-jb-hint]');
          const idle = status.textContent, hintText = hint.textContent;
          fail = (msg) => { box.classList.add('is-error'); box.classList.remove('is-done'); status.textContent = idle; hint.textContent = msg; box.querySelector('.jb-drop').scrollIntoView({ block: 'center' }); };
          input.addEventListener('change', () => {
            const f = input.files[0];
            box.classList.remove('is-done', 'is-error'); hint.textContent = hintText; status.textContent = idle;
            if (!f) return;
            if (f.size > MAX) { input.value = ''; return fail('That file is over 10 MB.'); }
            status.textContent = f.name; box.classList.add('is-done');
            hint.textContent = 'Attached. Choose another file to replace it.';
          });
        }
        const showError = (msg) => {
          let el = form.querySelector('.ev-error');
          if (!el) { el = document.createElement('div'); el.className = 'ev-error'; el.setAttribute('role', 'alert'); form.prepend(el); }
          el.textContent = msg; el.scrollIntoView({ block: 'center' });
        };
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          if (box && box.dataset.required === 'true' && !box.querySelector('[data-jb-input]').files.length) return fail('Please attach your resume.');
          const label = submit.textContent;
          submit.disabled = true; submit.textContent = 'Sending…';
          try {
            const r = await fetch(endpoint, { method: 'POST', body: new FormData(form) });
            const j = await r.json().catch(() => ({}));
            if (!r.ok || !j.ok) throw new Error(j.error || 'Something went wrong. Please try again.');
            const ok = document.createElement('div');
            ok.className = 'ev-success'; ok.setAttribute('role', 'status'); ok.tabIndex = -1;
            ok.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8 12.5l2.7 2.7L16 9.8"/></svg><p></p>';
            ok.querySelector('p').textContent = root.dataset.jbSuccess;
            form.replaceChildren(ok);
            ok.scrollIntoView({ block: 'center' }); ok.focus({ preventScroll: true });
          } catch (err) {
            showError(err.message);
            submit.disabled = false; submit.textContent = label;
          }
        });
      }
    };
    const boot = () => document.querySelectorAll('[data-jttp-job]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jttp-lookbook"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('jttp-lookbook')) return;

    const ICONS = {
      prev: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M13 8H3M7 4 3 8l4 4"/></svg>',
      next: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M3 8h10M9 4l4 4-4 4"/></svg>',
      close: '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M1 1l12 12M13 1 1 13"/></svg>',
      check: '<svg viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="2"><path d="M1.5 5.2 4 7.5l4.5-5"/></svg>'
    };
    const SIZE_RE = /size|taille|größe/i;
    const COLOR_RE = /colou?r|shade|wash/i;
    const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const pad = (n) => String(n).padStart(2, '0');
    const norm = (s) => String(s ?? '').trim().toLowerCase();
    const REDUCED = matchMedia('(prefers-reduced-motion: reduce)');
    // Stand-in figure for looks that don't have a model image yet (theme editor).
    const PLACEHOLDER = (tint) => 'data:image/svg+xml,' + encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 1000"><g fill="${tint || '#c9c2b8'}" opacity=".55">` +
      '<ellipse cx="200" cy="92" rx="40" ry="50"/><rect x="184" y="132" width="32" height="40" rx="10"/>' +
      '<path d="M120 190q4-22 52-26h56q48 4 52 26l12 270H108z"/><path d="M118 192 88 450h30l26-230zM282 192l30 258h-30l-26-230z"/>' +
      '<path d="M112 452h176l-14 478h-62l-12-360-12 360h-62z"/><ellipse cx="157" cy="944" rx="34" ry="13"/><ellipse cx="243" cy="944" rx="34" ry="13"/>' +
      '</g></svg>');

    class JttpLookbook extends HTMLElement {
      connectedCallback() {
        const raw = this.querySelector('[data-lookbook-data]');
        if (!raw || this.data) return;
        try { this.data = JSON.parse(raw.textContent); } catch (e) { console.error('[lookbook] bad data', e); return; }
        const d = this.data;
        const nf = (digits) => new Intl.NumberFormat(d.locale || undefined, { style: 'currency', currency: d.currency || 'USD', minimumFractionDigits: digits, maximumFractionDigits: digits });
        this.money = { whole: nf(0), cents: nf(2) };
        this.looks = (d.looks || []).filter((l) => l.colorways.length).map((l) => this.prepLook(l));
        const rankOf = (l) => (Number.isFinite(Number(l.sort)) && l.sort !== null && l.sort !== '' ? Number(l.sort) : 9999);
        this.looks.sort((a, b) => rankOf(a) - rankOf(b));
        const tabOrder = String(d.tabOrder || '').split(',').map((t) => norm(t)).filter(Boolean);
        const rank = (g) => { const i = tabOrder.indexOf(norm(g)); return i < 0 ? 999 : i; };
        this.groups = [...new Set(this.looks.map((l) => l.group))].sort((a, b) => rank(a) - rank(b));
        this.state = { group: this.groups[0], active: {}, cw: {} };
        this.groups.forEach((g) => {
          const n = this.looks.filter((l) => l.group === g).length;
          this.state.active[g] = Math.min(3, n - 1); // open mid-row so the lineup reads straight away
        });
        this.render();
        this.bind();
        this.layout(true);
        this.ro = new ResizeObserver(() => this.layout(true));
        this.ro.observe(this.stage);
      }

      disconnectedCallback() { this.ro?.disconnect(); }

      prepLook(look) {
        look.colorways.forEach((c) => { if (!c.image) c.image = PLACEHOLDER(c.swatch); });
        look.pieces = look.pieces.map((p) => {
          const opts = (p.options || []).map((o) => (typeof o === 'string' ? o : o.name));
          return { ...p, opts, sizeIdx: opts.findIndex((o) => SIZE_RE.test(o)), colorIdx: opts.findIndex((o) => COLOR_RE.test(o)) };
        });
        return look;
      }

      /* ---------- data helpers ---------- */
      get groupLooks() { return this.looks.filter((l) => l.group === this.state.group); }
      get activeIdx() { return this.state.active[this.state.group]; }
      get activeLook() { return this.groupLooks[this.activeIdx]; }
      cwIdx(look) { return this.state.cw[look.id] || 0; }
      cw(look) { return look.colorways[this.cwIdx(look)]; }

      // Variants of a piece that belong to the look's current colourway.
      colorVariants(piece, look) {
        const name = norm(this.cw(look).name);
        const vs = piece.variants;
        if (!name) return vs;
        const byColorOpt = piece.colorIdx >= 0 ? vs.filter((v) => norm(v.options[piece.colorIdx]) === name) : [];
        if (byColorOpt.length) return byColorOpt;
        const byAny = vs.filter((v) => v.options.some((o) => norm(o) === name));
        return byAny.length ? byAny : vs;
      }
      pickVariant(piece, look, size) {
        const vs = this.colorVariants(piece, look);
        if (piece.sizeIdx >= 0 && size) {
          return vs.find((v) => v.options[piece.sizeIdx] === size) || null;
        }
        return vs.find((v) => v.available) || vs[0];
      }
      pieceImage(piece, look) {
        const v = this.colorVariants(piece, look).find((x) => x.image);
        return (v && v.image) || piece.image;
      }
      piecePrice(piece, look) {
        const vs = this.colorVariants(piece, look);
        const pool = vs.filter((v) => v.available).length ? vs.filter((v) => v.available) : vs;
        return Math.min(...pool.map((v) => v.price));
      }
      lookPrice(look) { return look.pieces.reduce((t, p) => t + this.piecePrice(p, look), 0); }
      fmt(cents) { return (cents % 100 ? this.money.cents : this.money.whole).format(cents / 100); }
      sizesFor(piece, look) {
        if (piece.sizeIdx < 0) return [];
        const seen = new Map();
        this.colorVariants(piece, look).forEach((v) => {
          const s = v.options[piece.sizeIdx];
          seen.set(s, (seen.get(s) || false) || v.available);
        });
        return [...seen].map(([size, available]) => ({ size, available }));
      }

      /* ---------- render ---------- */
      render() {
        const s = this.data.settings;
        const showRail = s.showRail !== false;
        const tabs = this.groups.length > 1
          ? `<div class="lb-tabs" role="tablist" aria-label="Lookbook">${this.groups.map((g, i) =>
              `<button type="button" class="lb-tab" role="tab" data-group="${esc(g)}" aria-selected="${i === 0}">${esc(g)}</button>`).join('')}</div>`
          : '';
        const tracks = this.groups.map((g, gi) => {
          const looks = this.looks.filter((l) => l.group === g);
          return `<div class="lb-track" data-group="${esc(g)}"${gi ? ' hidden' : ''}>${looks.map((l, i) => {
            const c = l.colorways[0];
            return `<button type="button" class="lb-fig" data-look="${esc(l.id)}" data-i="${i}" aria-label="Look ${i + 1}: ${esc(l.title)}">
              <span class="lb-fig__frame"><span class="lb-fig__shadow"></span>${c.image ? `<img class="lb-fig__img" src="${esc(c.image)}" alt="${esc(c.alt || l.title)}" draggable="false" loading="${i < 6 ? 'eager' : 'lazy'}">` : ''}</span>
              <span class="lb-fig__hint">View the look</span>
            </button>`;
          }).join('')}</div>`;
        }).join('');

        this.innerHTML = `
          <div class="lb-wrap${showRail ? '' : ' lb-wrap--no-rail'}">
            <header class="lb-head">
              <div>
                ${s.eyebrow ? `<p class="lb-eyebrow">${esc(s.eyebrow)}</p>` : ''}
                <h2 class="lb-title">${esc(s.heading)} <span class="lb-title__group">${esc(this.groups.length > 1 ? this.state.group : '')}</span></h2>
                ${s.subheading ? `<p class="lb-sub">${esc(s.subheading)}</p>` : ''}
              </div>
              ${tabs}
            </header>
            <div class="lb-stage" tabindex="0" role="region" aria-roledescription="carousel" aria-label="${esc(s.heading)}">
              <div class="lb-floor" aria-hidden="true"></div>
              ${tracks}
            </div>
            <div class="lb-bar">
              <div class="lb-caption" data-caption></div>
              <div class="lb-controls">
                <div class="lb-swatches" data-swatches role="group" aria-label="Colour"></div>
                <button type="button" class="lb-shop" data-open>${esc(s.shopLabel || 'Shop the look')} <span class="lb-pill" data-price></span></button>
              </div>
              <div class="lb-arrows">
                <span class="lb-count" data-count></span>
                <button type="button" class="lb-arrow" data-prev aria-label="Previous look">${ICONS.prev}</button>
                <button type="button" class="lb-arrow lb-arrow--next" data-next aria-label="Next look">${ICONS.next}</button>
              </div>
            </div>
            ${showRail ? `<aside class="lb-rail" aria-label="${esc(s.railLabel || 'In this look')}">
              <p class="lb-rail__label">${esc(s.railLabel || 'In this look')}</p>
              <ul class="lb-rail__list" role="list" data-rail></ul>
            </aside>` : ''}
            <p class="lb-live" aria-live="polite" data-live></p>
          </div>
          <dialog class="lb-dialog" aria-label="Look details"></dialog>`;

        this.stage = this.querySelector('.lb-stage');
        this.dialog = this.querySelector('.lb-dialog');
        this.syncUi(false);
      }

      syncUi(announce = true) {
        const look = this.activeLook;
        if (!look) return;
        const looks = this.groupLooks;
        const cw = this.cw(look);
        const q = (sel) => this.querySelector(sel);

        q('[data-caption]').innerHTML = `<strong>${esc(look.title)}</strong>${look.pieces.length} piece${look.pieces.length === 1 ? '' : 's'}`;
        q('[data-count]').textContent = `${pad(this.activeIdx + 1)} / ${pad(looks.length)}`;
        q('[data-prev]').disabled = this.activeIdx === 0;
        q('[data-next]').disabled = this.activeIdx === looks.length - 1;
        q('[data-price]').textContent = look.pieces.length ? this.fmt(this.lookPrice(look)) : '';
        q('[data-open]').hidden = !look.pieces.length;

        const sw = q('[data-swatches]');
        sw.hidden = look.colorways.length < 2 && !cw.name;
        sw.innerHTML = this.swatchHtml(look);

        const rail = q('[data-rail]');
        if (rail) {
          rail.innerHTML = look.pieces.map((p, i) => `<li><button type="button" class="lb-piece" data-piece="${i}" style="--i:${i}">
            <span class="lb-piece__media">${this.pieceImage(p, look) ? `<img src="${esc(this.pieceImage(p, look))}" alt="" loading="lazy">` : ''}</span>
            <span class="lb-piece__title">${esc(p.title)}</span>
            <span class="lb-piece__meta"><span>${esc(cw.name || '')}</span><span>${this.fmt(this.piecePrice(p, look))}</span></span>
          </button></li>`).join('');
        }
        if (announce) q('[data-live]').textContent = `Look ${this.activeIdx + 1} of ${looks.length}: ${look.title}${cw.name ? `, ${cw.name}` : ''}`;
      }

      swatchHtml(look) {
        const cw = this.cw(look);
        return `<span class="lb-swatches__name" data-cw-name>${esc(cw.name || '')}</span>${look.colorways.length > 1 ? look.colorways.map((c, i) =>
          `<button type="button" class="lb-swatch" data-cw="${i}" style="--sw:${esc(c.swatch || '#bbb')}" aria-pressed="${i === this.cwIdx(look)}" aria-label="${esc(c.name || `Colour ${i + 1}`)}"></button>`).join('') : ''}`;
      }

      /* ---------- the lineup ---------- */
      layout(instant = false) {
        const track = this.querySelector(`.lb-track[data-group="${CSS.escape(this.state.group)}"]`);
        if (!track) return;
        const W = this.stage.clientWidth;
        const H = track.clientHeight;
        const ratio = parseFloat(getComputedStyle(this).getPropertyValue('--lb-ratio')) || 0.4;
        const mobile = W < 560;
        const w = Math.min(H * ratio, W * (mobile ? 0.5 : 0.3));
        const anchor = W * (mobile ? 0.6 : 0.7);
        // Depth comes mostly from the wash-out in place(); the size drop stays small so
        // nobody behind looks tiny.
        const shrink = mobile ? 0.05 : 0.03;
        const gap = mobile ? 0.6 : 0.8;
        const figs = [...track.children];
        const a = this.activeIdx;

        if (instant) figs.forEach((f) => (f.style.transition = 'none'));
        let x = anchor;
        let prevW = w;
        const scaleAt = (d) => Math.max(0.84, 1 - shrink * Math.abs(d));
        figs.forEach((f) => f.style.setProperty('--w', `${w}px`));
        for (let i = a; i >= 0; i--) {
          const d = i - a;
          const s = scaleAt(d);
          if (d < 0) x -= (prevW / 2 + (w * s) / 2) * gap;
          prevW = w * s;
          this.place(figs[i], { x, w, s, d, mobile });
        }
        for (let i = a + 1; i < figs.length; i++) {
          const d = i - a;
          const nx = anchor + w * (mobile ? 0.78 : 0.92) * d;
          this.place(figs[i], { x: nx, w, s: 1, d, mobile });
        }
        if (instant) {
          track.offsetHeight; // flush
          figs.forEach((f) => (f.style.transition = ''));
        }
      }

      place(f, { x, w, s, d, mobile }) {
        const left = x - w / 2;
        const visibleBehind = mobile ? 3 : 7;
        let o = 1, b = 0, sat = 1, br = 1, ct = 1;
        if (d < 0) {
          // each step back: lighter, flatter, slightly softer (like it's further into the haze)
          const far = Math.abs(d);
          const wash = Math.min(1, far / 5);
          o = far > visibleBehind ? 0 : 1 - wash * 0.45;
          sat = 1 - wash * 0.55;
          br = 1 + wash * 0.22;
          ct = 1 - wash * 0.35;
          b = Math.max(0, far - 1) * 0.45;
          if (left + w * s < -20) o = 0;
        } else if (d === 1) { o = 0.2; b = 2.5; sat = 0.7; br = 1.1; ct = 0.8; }
        else if (d > 1) { o = 0; b = 4; }
        f.style.setProperty('--x', `${left}px`);
        f.style.setProperty('--s', s.toFixed(3));
        f.style.setProperty('--o', o.toFixed(3));
        f.style.setProperty('--b', `${b}px`);
        f.style.setProperty('--sat', sat.toFixed(2));
        f.style.setProperty('--br', br.toFixed(3));
        f.style.setProperty('--ct', ct.toFixed(3));
        f.style.setProperty('--z', String(100 - Math.abs(d)));
        f.classList.toggle('is-active', d === 0);
        f.classList.toggle('is-before', d < 0);
        const hidden = o === 0;
        f.setAttribute('aria-hidden', String(hidden));
        f.tabIndex = d === 0 ? 0 : -1;
        if (d === 0) f.setAttribute('aria-current', 'true'); else f.removeAttribute('aria-current');
      }

      go(i) {
        const n = this.groupLooks.length;
        const next = Math.max(0, Math.min(n - 1, i));
        if (next === this.activeIdx) return;
        this.state.active[this.state.group] = next;
        this.layout();
        this.syncUi();
      }

      setGroup(g) {
        if (g === this.state.group) return;
        this.state.group = g;
        this.querySelectorAll('.lb-tab').forEach((t) => t.setAttribute('aria-selected', String(t.dataset.group === g)));
        this.querySelectorAll('.lb-track').forEach((t) => (t.hidden = t.dataset.group !== g));
        const title = this.querySelector('.lb-title__group');
        title.classList.add('is-swapping');
        setTimeout(() => { title.textContent = g; title.classList.remove('is-swapping'); }, 220);
        this.layout(true);
        // stagger the lineup in from the right
        if (!REDUCED.matches) {
          this.querySelectorAll(`.lb-track[data-group="${CSS.escape(g)}"] .lb-fig__frame`).forEach((f, i) => {
            f.animate([{ opacity: 0, transform: 'translateX(70px)' }, { opacity: 1, transform: 'none' }],
              { duration: 700, delay: Math.min(i, 8) * 50, easing: 'cubic-bezier(.22,.8,.24,1)', fill: 'backwards' });
          });
        }
        this.syncUi();
      }

      setColorway(look, i) {
        if (this.cwIdx(look) === i) return;
        this.state.cw[look.id] = i;
        const c = look.colorways[i];
        const fig = this.querySelector(`.lb-fig[data-look="${CSS.escape(look.id)}"] .lb-fig__frame`);
        if (fig && c.image) this.swapImg(fig, c.image, c.alt || look.title);
        if (look === this.activeLook) this.syncUi();
        if (this.dialog.open && this.detailLook === look) this.renderDetail(true);
      }

      swapImg(frame, src, alt) {
        const old = frame.querySelector('.lb-fig__img:not(.is-leaving)');
        const img = new Image();
        img.className = 'lb-fig__img is-entering';
        img.alt = alt;
        img.draggable = false;
        img.src = src;
        const show = () => {
          frame.appendChild(img);
          requestAnimationFrame(() => requestAnimationFrame(() => img.classList.remove('is-entering')));
          if (old) { old.classList.add('is-leaving-under'); setTimeout(() => old.remove(), 520); } // new image fades in on top
        };
        img.decode ? img.decode().then(show, show) : (img.onload = show);
      }

      /* ---------- events ---------- */
      bind() {
        this.addEventListener('click', (e) => {
          const t = e.target;
          const fig = t.closest('.lb-fig');
          if (fig) {
            const i = +fig.dataset.i;
            if (i === this.activeIdx) this.openDetail(this.activeLook);
            else this.go(i);
            return;
          }
          const sw = t.closest('[data-cw]');
          if (sw) {
            const look = this.dialog.contains(sw) ? this.detailLook : this.activeLook;
            this.setColorway(look, +sw.dataset.cw);
            return;
          }
          if (t.closest('.lb-tab')) return this.setGroup(t.closest('.lb-tab').dataset.group);
          if (t.closest('[data-prev]')) return this.go(this.activeIdx - 1);
          if (t.closest('[data-next]')) return this.go(this.activeIdx + 1);
          if (t.closest('[data-open]')) return this.openDetail(this.activeLook);
          const piece = t.closest('[data-piece]');
          if (piece && !this.dialog.contains(piece)) return this.openDetail(this.activeLook, 1 + +piece.dataset.piece);
        });

        this.stage.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.go(this.activeIdx - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.activeIdx + 1); }
        });

        // swipe / drag
        let sx = null, sy = 0, moved = false;
        this.stage.addEventListener('pointerdown', (e) => { sx = e.clientX; sy = e.clientY; moved = false; });
        this.stage.addEventListener('pointermove', (e) => { if (sx !== null && Math.abs(e.clientX - sx) > 8) moved = true; });
        this.stage.addEventListener('pointerup', (e) => {
          if (sx === null) return;
          const dx = e.clientX - sx, dy = e.clientY - sy;
          sx = null;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) this.go(this.activeIdx + (dx < 0 ? 1 : -1));
        });
        this.stage.addEventListener('click', (e) => { if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; } }, true);

        // theme editor: selecting a block jumps to that look
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail?.sectionId !== this.id.replace('jttp-lookbook-', '')) return;
          const look = this.looks.find((l) => l.id === e.detail.blockId);
          if (!look) return;
          this.setGroup(look.group);
          this.go(this.groupLooks.indexOf(look));
        });

        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog) return this.closeDetail();
          this.onDetailClick(e);
        });
        this.dialog.addEventListener('change', (e) => {
          const box = e.target.closest('[data-toggle]');
          if (box) { this.sel.checked[+box.dataset.toggle] = box.checked; this.renderDetail(true); }
        });
        this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.closeDetail(); });
      }

      /* ---------- detail sheet ---------- */
      openDetail(look, media = 0) {
        if (!look || !look.pieces.length) return;
        this.detailLook = look;
        this.sel = { checked: look.pieces.map(() => true), size: {}, media, flagged: false };
        this.renderDetail();
        this.lastFocus = document.activeElement;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        this.dialog.querySelector('.lb-detail__close').focus();
      }

      closeDetail() {
        if (!this.dialog.open) return;
        this.dialog.classList.add('is-closing');
        setTimeout(() => {
          this.dialog.classList.remove('is-closing');
          this.dialog.close();
          document.documentElement.style.overflow = '';
          this.lastFocus?.focus?.();
        }, 260);
      }

      mediaList(look) {
        const c = this.cw(look);
        return [
          { src: c.image, alt: c.alt || look.title, flat: false },
          ...look.pieces.map((p) => ({ src: this.pieceImage(p, look), alt: p.title, flat: true }))
        ].filter((m) => m.src);
      }

      renderDetail(keepScroll = false) {
        const look = this.detailLook;
        const s = this.data.settings;
        const c = this.cw(look);
        const media = this.mediaList(look);
        const mi = Math.min(this.sel.media, media.length - 1);
        const idx = this.groupLooks.indexOf(look);
        const info = this.dialog.querySelector('.lb-info');
        const scroll = keepScroll && info ? info.scrollTop : 0;

        const rows = look.pieces.map((p, i) => {
          const sizes = this.sizesFor(p, look);
          const chosen = this.sel.size[i];
          if (chosen && !sizes.some((z) => z.size === chosen && z.available)) delete this.sel.size[i];
          const v = this.pickVariant(p, look, this.sel.size[i]);
          const price = v ? v.price : this.piecePrice(p, look);
          const on = this.sel.checked[i];
          const needs = this.sel.flagged && on && sizes.length > 1 && !this.sel.size[i];
          const soldOut = !this.colorVariants(p, look).some((x) => x.available);
          return `<div class="lb-row${on ? '' : ' is-off'}${needs ? ' needs-size' : ''}">
            <label class="lb-check"><input type="checkbox" data-toggle="${i}"${on ? ' checked' : ''}${soldOut ? ' disabled' : ''} aria-label="Include ${esc(p.title)}"><span>${ICONS.check}</span></label>
            ${this.pieceImage(p, look) ? `<img class="lb-row__img" src="${esc(this.pieceImage(p, look))}" alt="">` : '<span></span>'}
            <span class="lb-row__title"><a href="${esc(p.url)}">${esc(p.title)}</a><span class="lb-row__sub">${soldOut ? 'Sold out' : esc(c.name || '')}</span></span>
            <span class="lb-row__price">${this.fmt(price)}</span>
            ${sizes.length > 1 ? `<div class="lb-sizes" role="group" aria-label="Size for ${esc(p.title)}">${sizes.map((z) =>
              `<button type="button" class="lb-size" data-size="${esc(z.size)}" data-row="${i}" aria-pressed="${this.sel.size[i] === z.size}"${z.available && on ? '' : ' disabled'}>${esc(z.size)}</button>`).join('')}</div>` : ''}
            ${needs ? '<span class="lb-row__note">Pick a size</span>' : ''}
          </div>`;
        }).join('');

        const total = look.pieces.reduce((t, p, i) => {
          if (!this.sel.checked[i]) return t;
          const v = this.pickVariant(p, look, this.sel.size[i]);
          return t + (v ? v.price : this.piecePrice(p, look));
        }, 0);
        const count = this.sel.checked.filter(Boolean).length;

        this.dialog.innerHTML = `
          <button type="button" class="lb-detail__close" data-close aria-label="Close">${ICONS.close}</button>
          <div class="lb-detail">
            <div class="lb-thumbs" role="group" aria-label="Images">${media.map((m, i) =>
              `<button type="button" class="lb-thumb" data-media="${i}" aria-current="${i === mi}" aria-label="${esc(m.alt)}"><img src="${esc(m.src)}" alt=""></button>`).join('')}</div>
            <div class="lb-media">${media[mi] ? `<img src="${esc(media[mi].src)}" alt="${esc(media[mi].alt)}"${media[mi].flat ? ' class="is-flat"' : ''}>` : ''}</div>
            <div class="lb-info">
              <div>
                <p class="lb-info__eyebrow">${esc(look.group)} · Look ${pad(idx + 1)}</p>
                <h3 class="lb-info__title">${esc(look.title)}</h3>
                <p class="lb-info__price">${this.fmt(this.lookPrice(look))} <small>${look.pieces.length} piece${look.pieces.length === 1 ? '' : 's'}</small></p>
              </div>
              ${look.story ? `<p class="lb-info__story">${esc(look.story)}</p>` : ''}
              ${look.colorways.length > 1 ? `<div>
                <p class="lb-info__label">Colour <span>${esc(c.name || '')}</span></p>
                <div class="lb-swatches" role="group" aria-label="Colour">${look.colorways.map((cc, i) =>
                  `<button type="button" class="lb-swatch" data-cw="${i}" style="--sw:${esc(cc.swatch || '#bbb')}" aria-pressed="${i === this.cwIdx(look)}" aria-label="${esc(cc.name || `Colour ${i + 1}`)}"></button>`).join('')}</div>
              </div>` : ''}
              <div>
                <p class="lb-info__label">Pieces in this look</p>
                <div class="lb-rows">${rows}</div>
              </div>
              <div class="lb-actions">
                <button type="button" class="lb-add" data-add${count ? '' : ' disabled'}>
                  <span>${esc(s.addLabel || 'Add the look to bag')}</span><span class="lb-pill">${this.fmt(total)}</span>
                </button>
                ${s.secondaryLabel && s.secondaryUrl ? `<a class="lb-secondary" href="${esc(s.secondaryUrl)}">${esc(s.secondaryLabel)}</a>` : ''}
                <p class="lb-status" role="status" data-status></p>
              </div>
            </div>
          </div>`;
        if (scroll) this.dialog.querySelector('.lb-info').scrollTop = scroll;
      }

      onDetailClick(e) {
        const t = e.target;
        if (t.closest('[data-close]')) return this.closeDetail();
        const th = t.closest('[data-media]');
        if (th) { this.sel.media = +th.dataset.media; return this.renderDetail(true); }
        const sz = t.closest('[data-size]');
        if (sz) {
          const r = +sz.dataset.row;
          this.sel.size[r] = this.sel.size[r] === sz.dataset.size ? undefined : sz.dataset.size;
          this.renderDetail(true);
          this.dialog.querySelector(`[data-row="${r}"][data-size="${CSS.escape(sz.dataset.size)}"]`)?.focus();
          return;
        }
        if (t.closest('[data-add]')) this.addToBag();
      }

      async addToBag() {
        const look = this.detailLook;
        const items = [];
        let missing = false;
        look.pieces.forEach((p, i) => {
          if (!this.sel.checked[i]) return;
          const sizes = this.sizesFor(p, look);
          if (sizes.length > 1 && !this.sel.size[i]) { missing = true; return; }
          const v = this.pickVariant(p, look, this.sel.size[i]);
          if (v && v.available) items.push({ id: v.id, quantity: 1 });
        });
        if (missing) {
          this.sel.flagged = true;
          this.renderDetail(true);
          this.setStatus('Pick a size for each piece.', true);
          this.dialog.querySelector('.needs-size')?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
          return;
        }
        if (!items.length) return this.setStatus('Nothing available to add.', true);

        const btn = this.dialog.querySelector('[data-add]');
        btn.classList.add('is-busy');
        btn.disabled = true;
        const root = (this.data.root || '/').replace(/\/?$/, '/');
        const drawer = document.querySelector('cart-drawer');
        const notification = document.querySelector('cart-notification');
        const sections = drawer?.getSectionsToRender?.().map((x) => x.id) || notification?.getSectionsToRender?.().map((x) => x.id) || ['cart-icon-bubble'];
        try {
          const res = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items, sections, sections_url: window.location.pathname })
          });
          const json = await res.json();
          if (!res.ok || json.status) throw new Error(json.description || json.message || 'Could not add to bag');
          document.dispatchEvent(new CustomEvent('lookbook:added', { bubbles: true, detail: { look: look.title, items, response: json } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (drawer?.renderContents) {
            this.closeDetail();
            drawer.classList.remove('is-empty');
            setTimeout(() => drawer.renderContents(json), 280);
            return;
          }
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubble && json.sections?.['cart-icon-bubble']) {
            const doc = new DOMParser().parseFromString(json.sections['cart-icon-bubble'], 'text/html');
            const inner = doc.querySelector('.shopify-section');
            if (inner) bubble.innerHTML = inner.innerHTML;
          }
          this.setStatus(`Added ${items.length} piece${items.length === 1 ? '' : 's'} · <a href="${root}cart">View bag</a>`);
        } catch (err) {
          this.setStatus(esc(err.message), true);
        } finally {
          btn.classList.remove('is-busy');
          btn.disabled = false;
        }
      }

      setStatus(html, error = false) {
        const el = this.dialog.querySelector('[data-status]');
        if (!el) return;
        el.classList.toggle('is-error', error);
        el.innerHTML = html;
      }
    }

    customElements.define('jttp-lookbook', JttpLookbook);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jttp-market"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const MONTHS = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
    const DOW = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const pad = (n) => String(n).padStart(2, '0');
    // "October 3 2026" / "Oct 3, 2026" → Date (same parser idea as the booking map)
    const parseDate = (s) => {
      const m = String(s).match(/([A-Za-z]+)\.?\s+(\d{1,2}),?\s+(\d{4})/);
      if (!m) return null;
      const mo = MONTHS.findIndex((x) => x.startsWith(m[1].toLowerCase().slice(0, 3)));
      return mo < 0 ? null : new Date(+m[3], mo, +m[2]);
    };
    const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    // Pacific time, like the booking map: a day is past once it's over in Joshua Tree; today stays bookable.
    const TODAY = (() => { try { return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Los_Angeles', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date()); } catch { return iso(new Date()); } })();

    const init = (root) => {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = '1';
      root.classList.add('has-js');
      const $ = (s) => root.querySelector(s);
      const $$ = (s) => [...root.querySelectorAll(s)];
      const t = (k) => root.dataset[k] || '';
      const fill = (s, map) => s.replace(/\[(\w+)\]/g, (_, k) => (k in map ? map[k] : `[${k}]`));
      const money = (c) => { try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: root.dataset.currency, maximumFractionDigits: c % 100 ? 2 : 0 }).format(c / 100); } catch { return '$' + c / 100; } };
      requestAnimationFrame(() => root.classList.add('is-ready'));

      /* space kinds: "Table = Tables" lines; anything else falls into the first kind */
      const kinds = (root.dataset.kinds || '').split(/\n/).map((l) => l.split('=').map((x) => x.trim())).filter((p) => p.length > 1 && p[0]);
      const kindOf = (space) => {
        const k = kinds.find(([prefix]) => space.toLowerCase().startsWith(prefix.toLowerCase()));
        return k ? k[1] : (kinds[0] ? kinds[0][1] : 'Spaces');
      };

      /* ---------- build months from the booking products ---------- */
      const data = JSON.parse($('[data-mk-data]')?.textContent || '[]');
      const months = data.filter((p) => p.di >= 0 && p.si >= 0).map((p) => {
        const days = new Map();
        p.v.forEach(([id, opts, avail, price]) => {
          const label = opts[p.di], space = opts[p.si];
          const d = parseDate(label);
          if (!d) return;
          const key = iso(d);
          if (!days.has(key)) days.set(key, { key, date: d, label, spaces: [] });
          days.get(key).spaces.push({ id, space, kind: kindOf(space), avail: !!avail, price });
        });
        // past market days drop off (same Pacific-time rule as the booking map; today stays)
        const list = [...days.values()].filter((d) => d.key >= TODAY).sort((a, b) => (a.key < b.key ? -1 : 1));
        const first = list[0]?.date;
        return { title: p.title, url: p.url, days: list, name: first ? first.toLocaleDateString('en-US', { month: 'long', year: 'numeric' }) : p.title, short: first ? first.toLocaleDateString('en-US', { month: 'long' }) : p.title };
      }).filter((m) => m.days.length).sort((a, b) => (a.days[0].key < b.days[0].key ? -1 : 1));

      const few = +root.dataset.few || 2;
      const dayState = (d) => {
        const open = d.spaces.filter((s) => s.avail).length;
        if (!open) return ['sold', t('tSold')];
        if (d.key === TODAY) return ['today', t('tToday')];
        if (open <= few) return ['few', fill(t('tFew'), { count: open })];
        return ['open', fill(t('tOpen'), { count: open })];
      };

      /* next market badge */
      const upcoming = months.flatMap((m) => m.days.map((d) => ({ ...d, url: m.url }))).find((d) => d.key >= TODAY && d.spaces.some((s) => s.avail));
      if (upcoming && $('[data-next]')) {
        const open = upcoming.spaces.filter((s) => s.avail).length;
        const when = upcoming.key === TODAY ? t('tToday') : `${DOW[upcoming.date.getDay()]} ${upcoming.date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`;
        $('[data-next-text]').textContent = fill(t('tNext'), { date: when, count: open });
        $('[data-next]').hidden = false;
      }

      const cal = $('[data-cal]');
      const arrow = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
      const dayHtml = (d, url) => {
        if (!d) return '<div class="mk-day mk-day--empty" aria-hidden="true"></div>';
        const [state, label] = dayState(d);
        const groups = new Map();
        d.spaces.forEach((s) => { if (!groups.has(s.kind)) groups.set(s.kind, []); groups.get(s.kind).push(s); });
        const kindsHtml = [...groups.entries()].map(([k, ss]) => {
          const open = ss.filter((s) => s.avail).length;
          const prices = [...new Set(ss.map((s) => s.price))];
          return `<div class="mk-kind"><span class="mk-kind__dots">${ss.map((s, i) => `<i class="mk-dot${s.avail ? ' mk-dot--on' : ''}" style="--i:${i}" title="${s.space}${s.avail ? '' : ' (taken)'}"></i>`).join('')}</span><span><b>${open}</b>/${ss.length} ${k} · ${prices.length > 1 ? fill(t('tFrom'), { price: money(Math.min(...prices)) }) : money(prices[0])}</span></div>`;
        }).join('');
        const first = d.spaces.find((s) => s.avail);
        const bookable = state !== 'sold';
        const tag = bookable ? 'a' : 'div';
        const href = bookable ? ` href="${url}${url.includes('?') ? '&' : '?'}variant=${first.id}"` : '';
        return `<${tag} class="mk-day mk-day--${state}"${href}>
          <span class="mk-day__date"><span class="mk-day__dow">${DOW[d.date.getDay()]}</span><span class="mk-day__num">${d.date.getDate()}</span></span>
          <span class="mk-day__top"><span class="mk-status mk-status--${state}">${label}</span></span>
          <span class="mk-day__kinds">${kindsHtml}</span>
          ${bookable ? `<span class="mk-day__go">${arrow}</span>` : ''}
        </${tag}>`;
      };
      const render = (mi) => {
        const m = months[mi];
        if (!m) { cal.innerHTML = ''; return; }
        // pair each Saturday with its Sunday; a lone day gets an empty partner
        const weeks = [];
        m.days.forEach((d) => {
          const dow = d.date.getDay();
          const last = weeks[weeks.length - 1];
          if (dow === 0 && last && !last.sun && last.sat && (d.date - last.sat.date) / 864e5 === 1) last.sun = d;
          else weeks.push(dow === 0 ? { sun: d } : { sat: d });
        });
        const total = m.days.reduce((a, d) => a + d.spaces.length, 0);
        const left = m.days.reduce((a, d) => a + d.spaces.filter((s) => s.avail).length, 0);
        $('[data-summary]').textContent = fill(t('tSummary'), { open: left, total, month: m.short });
        cal.innerHTML = weeks.map((w) => {
          const anchor = w.sat || w.sun;
          const end = w.sun || w.sat;
          const range = w.sat && w.sun ? `${w.sat.date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}–${w.sun.date.getDate()}` : anchor.date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
          const pair = w.sat && w.sun ? dayHtml(w.sat, m.url) + dayHtml(w.sun, m.url) : dayHtml(anchor, m.url) + dayHtml(null, m.url);
          return `<div class="mk-weekend mk-reveal is-in"><p class="mk-weekend__label">Weekend<b>${range}</b></p>${pair}</div>`;
        }).join('') + `<div class="mk-cal__foot"><a class="mk-btn mk-btn--solid" href="${m.url}">${fill(t('tBook'), { month: m.short })} ${arrow}</a></div>`;
        if (!reduce) { cal.classList.remove('is-swap'); void cal.offsetWidth; cal.classList.add('is-swap'); }
      };

      /* month tabs */
      const tabs = $('[data-months]');
      let current = Math.max(0, months.findIndex((m) => m.days.some((d) => d.key >= TODAY && d.spaces.some((s) => s.avail))));
      if (months.length > 1) {
        tabs.innerHTML = '<span class="mk-months__glider" data-glider></span>' + months.map((m, i) => `<button type="button" role="tab" class="mk-month" aria-selected="${i === current}" data-i="${i}">${m.name}</button>`).join('');
        tabs.hidden = false;
        const glide = () => { const on = tabs.querySelector('[aria-selected="true"]'); const g = $('[data-glider]'); if (on && g) { g.style.width = `${on.offsetWidth}px`; g.style.transform = `translateX(${on.offsetLeft - 4}px)`; } };
        tabs.addEventListener('click', (e) => {
          const b = e.target.closest('[data-i]'); if (!b) return;
          current = +b.dataset.i;
          tabs.querySelectorAll('[data-i]').forEach((x) => x.setAttribute('aria-selected', String(x === b)));
          glide(); render(current);
        });
        requestAnimationFrame(glide); document.fonts?.ready.then(glide); addEventListener('resize', glide, { passive: true });
      }
      if (months.length) render(current);
      else cal.innerHTML = '';

      /* reveal on scroll */
      const io = 'IntersectionObserver' in window && !reduce ? new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' }) : null;
      $$('.mk-reveal').forEach((el) => (io ? io.observe(el) : el.classList.add('is-in')));

      /* smooth jumps */
      $$('[data-jump]').forEach((a) => a.addEventListener('click', (e) => {
        const target = root.querySelector(a.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }));

      /* closing video: play while on screen, slow parallax */
      const close = $('[data-close]');
      if (close) {
        const v = close.querySelector('video');
        if (v) { v.muted = true; new IntersectionObserver(([en]) => { en.isIntersecting && !reduce && !document.hidden ? v.play().catch(() => {}) : v.pause(); }).observe(close); }
        if (!reduce) {
          const media = $('[data-close-media]');
          let tk = false;
          addEventListener('scroll', () => {
            if (tk) return; tk = true;
            requestAnimationFrame(() => { tk = false; const r = close.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return; media.style.transform = `translate3d(0, ${((r.top + r.height / 2 - innerHeight / 2) / innerHeight) * -8}%, 0)`; });
          }, { passive: true });
        }
      }
      const heroVid = $('.mk-hero__video video');
      if (heroVid) { heroVid.muted = true; if (reduce) heroVid.pause(); else heroVid.play?.().catch(() => {}); }
    };
    const boot = () => document.querySelectorAll('.jttp-mk').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('.jttp-mk')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jttp-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = '1';
      const $ = (s, el = root) => el.querySelector(s);
      const $$ = (s, el = root) => [...el.querySelectorAll(s)];
      const setText = (s, t) => { const el = $(s); if (el) el.textContent = t; };
      const show = (s, on) => { const el = typeof s === 'string' ? $(s) : s; if (el) el.hidden = !on; };
      const t = (k) => root.dataset[k] || '';
      const variants = JSON.parse($('[data-pd-variants]')?.textContent || '[]');
      const form = $('[data-pd-form]');
      const idInputs = $$('[data-variant-input]');
      const addBtn = $('[data-add]');
      const money = (cents) => {
        try { return new Intl.NumberFormat(root.dataset.locale, { style: 'currency', currency: root.dataset.currency }).format(cents / 100); }
        catch { return '$' + (cents / 100).toFixed(2); }
      };
      let current = variants.find((v) => String(v.id) === idInputs[0]?.value) || variants[0];

      /* ---------- tidy the pasted-in description ---------- */
      const descEl = $('[data-desc]');
      const srcTpl = $('[data-desc-src]');
      const desc = descEl || (srcTpl ? Object.assign(document.createElement('div'), { innerHTML: srcTpl.innerHTML }) : null);
      const brand = (root.dataset.brand || '').toLowerCase();
      if (desc) {
        const text = (el) => (el?.textContent || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim();
        const drop = (el) => el && el.remove();
        const esc = (s) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
        desc.querySelectorAll('meta, style, script').forEach(drop);
        // the "Free People" header the descriptions start with
        desc.querySelectorAll('h1, h2, h3, h4, p').forEach((el) => {
          if (brand && text(el).toLowerCase() === brand) drop(el);
        });
        let styleNo = '';
        let fitNote = '';
        const specs = [];
        const measures = [];
        desc.querySelectorAll('p').forEach((p) => {
          const tx = text(p);
          if (/^Style No/i.test(tx)) {
            const s = tx.match(/Style No\.?\s*([\w-]+)/i);
            const c = tx.match(/Color Code:?\s*([\w-]+)/i);
            styleNo = [s && `Style ${s[1]}`, c && `color ${c[1]}`].filter(Boolean).join(' · ');
            drop(p);
          } else if (/^Fit Note:?/i.test(tx)) {
            fitNote = tx.replace(/^Fit Note:?\s*/i, '');
            drop(p);
          }
        });
        // Care / Contents / Origin
        desc.querySelectorAll('h3, h4').forEach((h) => {
          const label = text(h);
          if (!/^(care|contents|origin|materials?|fabric)$/i.test(label)) return;
          const li = h.closest('li');
          let value = '';
          if (li) { value = text(li).slice(label.length).trim(); drop(li); }
          else { const n = h.nextElementSibling; value = text(n); drop(n); drop(h); }
          if (value) specs.push([label, value]);
        });
        // Measurements for size S / One Size
        desc.querySelectorAll('h3, h4').forEach((h) => {
          const label = text(h);
          if (!h.isConnected || !/^(measurements|one size)/i.test(label)) return;
          const list = h.nextElementSibling?.tagName === 'UL' ? h.nextElementSibling : null;
          if (!list) return;
          const items = [...list.children].map((li) => {
            const k = li.querySelector('span');
            const kt = text(k).replace(/:$/, '');
            const all = text(li);
            if (k && kt && /:$/.test(text(k)) && all.startsWith(kt)) return [kt, all.slice(text(k).length).trim()];
            specs.push(['Contents', all]);
            return null;
          }).filter(Boolean);
          const sz = label.match(/size\s+(.+)$/i);
          if (items.length) measures.push([/^one size/i.test(label) ? 'One size' : sz ? `Measured in size ${sz[1]}` : label, items]);
          drop(list); drop(h);
        });
        // the in-house label: a short heading followed by a one-line description ("We The Free", "FP Collection")
        let labelName = '';
        let labelHtml = '';
        desc.querySelectorAll('h3').forEach((h) => {
          const tx = text(h);
          if (!h.isConnected || labelName || !tx || tx.length > 32 || /measure|size|care|contents|origin/i.test(tx)) return;
          labelName = tx;
          const p = h.parentElement.querySelector(':scope > div p, :scope > p');
          if (p && text(p).length > 20 && h.compareDocumentPosition(p) & Node.DOCUMENT_POSITION_FOLLOWING) { labelHtml = p.outerHTML; drop(p); }
          drop(h);
        });
        // intro line is already shown under the title
        const dek = text($('[data-dek]'));
        if (dek) desc.querySelectorAll('p').forEach((p) => { if (text(p) === dek) drop(p); });
        // empty leftovers
        for (let i = 0; i < 4; i++) {
          desc.querySelectorAll('p, h2, h3, h4, li, ul, div, span, strong').forEach((el) => {
            if (!text(el) && !el.querySelector('img, iframe, video')) drop(el);
          });
        }
        desc.querySelectorAll('br').forEach((br) => { if (!br.previousSibling || !br.nextSibling) drop(br); });

        const panels = $('[data-panels]');
        if (descEl) {
          if (styleNo && panels?.dataset.styleno === 'true') desc.insertAdjacentHTML('beforeend', `<p class="pd-styleno">${styleNo}</p>`);
          if (!text(desc)) show('[data-panel="details"]', false);
        }
        if (fitNote) {
          setText('[data-fit-text]', fitNote);
          show('[data-fit]', true);
        }
        if ((fitNote || measures.length) && $('[data-fit-body]')) {
          $('[data-fit-body]').innerHTML = (fitNote ? `<p><strong>${esc($('[data-fit] b')?.textContent || 'Fit note')}:</strong> ${esc(fitNote)}</p>` : '') +
            measures.map(([l, items]) => `<div class="pd-measure"><h3>${esc(l)}</h3><dl class="pd-specs">${items.map(([k, v]) => `<dt>${esc(k)}</dt><dd>${esc(v)}</dd>`).join('')}</dl></div>`).join('');
          show('[data-panel="fit"]', true);
        }
        const sheet = $('[data-sheet-measures]');
        if (sheet && measures.length) {
          sheet.innerHTML = measures.map(([l, items]) => `<div class="pd-measure"><h3>${esc(l)}</h3><dl class="pd-specs">${items.map(([k, v]) => `<dt>${esc(k)}</dt><dd>${esc(v)}</dd>`).join('')}</dl></div>`).join('');
        }
        if (specs.length && $('[data-care-body]')) {
          $('[data-care-body]').innerHTML = `<dl class="pd-specs">${specs.map(([k, v]) => `<dt>${esc(k)}</dt><dd>${esc(v)}</dd>`).join('')}</dl>`;
          show('[data-panel="care"]', true);
        }
        if (labelName) {
          const lab = $('[data-label]');
          if (lab) { lab.textContent = labelName; lab.hidden = false; }
          if (panels) {
            setText('[data-about-title]', (panels.dataset.tAbout || 'About [label]').replace('[label]', labelName));
            if (labelHtml) $('[data-about-label]').innerHTML = labelHtml;
            show('[data-panel="about"]', true);
          }
        }
      }

      /* ---------- variants ---------- */
      const sets = $$('[data-opt]');
      const selected = () => sets.map((fs) => fs.querySelector('input:checked')?.value);
      const findVariant = (opts) => variants.find((v) => v.options.every((o, i) => opts[i] === undefined || o === opts[i]));
      const refreshValues = () => {
        const opts = selected();
        sets.forEach((fs, i) => {
          fs.querySelectorAll('input').forEach((input) => {
            const test = opts.slice(); test[i] = input.value;
            const v = findVariant(test);
            input.nextElementSibling.classList.toggle('is-out', !v || !v.available);
          });
          const out = fs.querySelector('[data-opt-value]');
          if (out) out.textContent = opts[i] || '';
        });
      };
      const gallery = $('[data-gallery]');
      const showMedia = (id) => {
        if (!id || !gallery) return;
        const shot = gallery.querySelector(`[data-media-id="${id}"]`);
        if (!shot) return;
        if (window.matchMedia('(min-width: 990px)').matches) {
          const lead = gallery.firstElementChild;
          if (lead !== shot) {
            const leadFull = lead.classList.contains('pd-shot--full');
            const shotFull = shot.classList.contains('pd-shot--full');
            lead.classList.toggle('pd-shot--full', shotFull);
            shot.classList.toggle('pd-shot--full', leadFull);
            const mark = document.createComment('');
            shot.replaceWith(mark);
            lead.replaceWith(shot);
            mark.replaceWith(lead);
          }
        } else {
          gallery.scrollTo({ left: shot.offsetLeft - gallery.offsetLeft - parseFloat(getComputedStyle(gallery).paddingLeft), behavior: 'smooth' });
        }
      };
      const stockLine = $('[data-stock]');
      const pickup = $('[data-pickup]');
      const dd = $('[data-dd]');
      const render = (v) => {
        current = v;
        const ok = !!v && v.available;
        if (v) idInputs.forEach((i) => { i.value = v.id; });
        setText('[data-price]', v ? money(v.price) : '');
        const onSale = v && v.compare > v.price;
        show('[data-compare]', onSale);
        show('[data-sale]', onSale);
        if (onSale) setText('[data-compare]', money(v.compare));
        if (addBtn) addBtn.disabled = !ok;
        setText('[data-add-text]', !v ? t('tUnavail') : ok ? t('tAdd') : t('tSold'));
        setText('[data-add-price]', ok ? money(v.price) : '');
        show('[data-dynamic]', ok);
        if (stockLine) {
          const lowN = +stockLine.dataset.low || 0;
          const low = ok && v.tracked && lowN > 0 && v.qty > 0 && v.qty <= lowN;
          stockLine.hidden = !low;
          if (low) stockLine.textContent = (v.qty === 1 ? stockLine.dataset.tOne : stockLine.dataset.tMany).replace('[count]', v.qty);
        }
        if (pickup) {
          const p = v && v.pickup;
          pickup.hidden = !p;
          if (p) {
            pickup.classList.toggle('is-no', !p.ok);
            setText('[data-pickup-title]', (p.ok ? pickup.dataset.tYes : pickup.dataset.tNo).replace('[location]', p.at));
            setText('[data-pickup-time]', p.ok ? p.time || '' : '');
          }
        }
        if (dd) {
          dd.hidden = !(v && v.dd);
          if (v && v.dd) $('[data-dd-link]').href = v.dd;
        }
        const barBtn = $('[data-bar-add]');
        if (barBtn) { barBtn.textContent = ok ? t('tAdd') : t('tSold'); barBtn.disabled = !ok; }
        if (v) setText('[data-bar-meta]', money(v.price) + (sets.length ? ` · ${v.title}` : ''));
        show('[data-error]', false);
      };
      sets.forEach((fs) => fs.addEventListener('change', () => {
        const v = findVariant(selected());
        refreshValues();
        render(v);
        if (v) {
          const url = new URL(location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', url);
          if (fs.classList.contains('pd-opt--color') || sets.length === 1) showMedia(v.media);
        }
        window.dispatchEvent(new CustomEvent(`theme:product:${root.dataset.section}:variantChanged`, { detail: { variant: v } }));
      }));
      refreshValues();
      render(current);

      /* quantity */
      const qty = $('[data-qty-input]');
      $$('[data-qty]').forEach((b) => b.addEventListener('click', () => {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + +b.dataset.qty);
      }));

      /* ---------- add to bag (theme cart drawer) ---------- */
      const errorEl = $('[data-error]');
      form?.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!current || !current.available) return;
        addBtn.setAttribute('aria-busy', 'true');
        errorEl.hidden = true;
        let Cart = null;
        try { ({ Cart } = await import('@troop-themes/main')); } catch {}
        const root_ = window.Shopify?.routes?.root || '/';
        try {
          const res = await fetch(`${root_}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: current.id, quantity: Math.max(1, parseInt(qty?.value, 10) || 1) }], sections: Cart?.sections || [] }),
          });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
          if (!Cart) { location.href = `${root_}cart`; return; }
          window.addEventListener('theme:cart:updated', () => requestAnimationFrame(() => window.dispatchEvent(new CustomEvent('theme:cart:open', { detail: addBtn }))), { once: true });
          Cart.fetchBasket?.().then(() => Cart.updateTotals([...Cart.basket.values()].reduce((a, b) => a + b, 0))).catch(() => {});
          if (data.sections && Object.keys(data.sections).length) Cart.updateAllHtml(data.sections, true);
          else window.dispatchEvent(new CustomEvent('theme:cart:open', { detail: addBtn }));
          setText('[data-add-text]', t('tAdded'));
          setTimeout(() => render(current), 1800);
        } catch (err) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        } finally {
          addBtn.removeAttribute('aria-busy');
        }
      });

      /* ---------- phone sticky bar ---------- */
      const bar = $('[data-bar]');
      const buy = $('.pd-buy');
      if (bar && buy && 'IntersectionObserver' in window) {
        new IntersectionObserver(([en]) => {
          const past = !en.isIntersecting && en.boundingClientRect.top < 0;
          bar.classList.toggle('is-on', past);
          bar.setAttribute('aria-hidden', String(!past));
          $('[data-bar-add]').tabIndex = past ? 0 : -1;
        }).observe(buy);
        $('[data-bar-add]').addEventListener('click', () => {
          if (!current?.available) return;
          form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      }

      /* ---------- both columns stick; a column taller than the window sticks by its bottom ---------- */
      if ('ResizeObserver' in window) {
        const cols = [[$('.pd-media'), '--pd-media-top'], [$('.pd-info'), '--pd-info-top']].filter(([el]) => el);
        const fit = () => {
          const stick = parseFloat(getComputedStyle(root).getPropertyValue('--pd-stick')) || 0;
          cols.forEach(([el, prop]) => root.style.setProperty(prop, `${Math.min(stick, window.innerHeight - el.offsetHeight - 24)}px`));
        };
        const ro = new ResizeObserver(fit);
        cols.forEach(([el]) => ro.observe(el));
        window.addEventListener('resize', fit, { passive: true });
      }

      /* ---------- gallery counter + viewer ---------- */
      const countNow = $('[data-count-now]');
      if (gallery && countNow) {
        gallery.addEventListener('scroll', () => {
          const x = gallery.scrollLeft + gallery.clientWidth / 3;
          let i = 0;
          [...gallery.children].forEach((s, k) => { if (s.offsetLeft - gallery.offsetLeft <= x) i = k; });
          countNow.textContent = i + 1;
        }, { passive: true });
      }
      const viewer = $('[data-viewer]');
      if (viewer && viewer.showModal) {
        const track = $('[data-viewer-track]', viewer);
        const go = (id) => {
          track.querySelectorAll('img[data-src]').forEach((img) => { img.src = img.dataset.src; img.removeAttribute('data-src'); });
          const slide = track.querySelector(`[data-media-id="${id}"]`);
          if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'instant' });
        };
        $$('[data-zoom]').forEach((b) => b.addEventListener('click', () => {
          viewer.showModal();
          go(b.closest('[data-media-id]').dataset.mediaId);
        }));
        $$('[data-viewer-step]', viewer).forEach((b) => b.addEventListener('click', () => {
          track.scrollBy({ left: track.clientWidth * +b.dataset.viewerStep, behavior: 'smooth' });
        }));
        viewer.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') track.scrollBy({ left: track.clientWidth * (e.key === 'ArrowRight' ? 1 : -1), behavior: 'smooth' });
        });
        $('[data-viewer-close]', viewer).addEventListener('click', () => viewer.close());
        viewer.addEventListener('click', (e) => { if (e.target === viewer || e.target.classList.contains('pd-viewer__slide')) viewer.close(); });
      }

      /* size guide sheet */
      $$('[data-open]').forEach((b) => b.addEventListener('click', () => $(`[data-sheet="${b.dataset.open}"]`)?.showModal()));
      $$('[data-sheet]').forEach((d) => {
        d.addEventListener('click', (e) => { if (e.target === d) d.close(); });
        d.querySelector('[data-sheet-close]')?.addEventListener('click', () => d.close());
      });

      /* more rail arrows */
      const rail = $('[data-rail-track]');
      $$('[data-rail]').forEach((b) => b.addEventListener('click', () => rail?.scrollBy({ left: rail.clientWidth * 0.75 * +b.dataset.rail, behavior: 'smooth' })));

      /* share */
      $('[data-copy]')?.addEventListener('click', async () => {
        const url = location.origin + root.dataset.productUrl;
        try {
          if (navigator.share && matchMedia('(pointer: coarse)').matches) { await navigator.share({ title: document.title, url }); return; }
          await navigator.clipboard.writeText(url);
          show('[data-copied]', true);
          setTimeout(() => show('[data-copied]', false), 2000);
        } catch {}
      });
    };

    const boot = () => document.querySelectorAll('.jttp-pd').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('.jttp-pd')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jttp-stays"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const init = (root) => {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = '1';
      root.classList.add('has-js');
      requestAnimationFrame(() => root.classList.add('is-ready'));
      const $$ = (s) => [...root.querySelectorAll(s)];

      /* reveal */
      const io = 'IntersectionObserver' in window && !reduce ? new IntersectionObserver((es) => es.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }), { rootMargin: '0px 0px -12% 0px' }) : null;
      $$('.st-reveal').forEach((el) => (io ? io.observe(el) : el.classList.add('is-in')));

      /* index: highlight the stay in view, keep the active chip visible */
      const chips = $$('[data-chip]');
      const list = root.querySelector('.st-index__list');
      const setOn = (n) => chips.forEach((c) => {
        const on = c.dataset.chip === n;
        if (on && !c.classList.contains('is-on') && list) list.scrollTo({ left: c.offsetLeft - list.offsetWidth / 2 + c.offsetWidth / 2, behavior: reduce ? 'auto' : 'smooth' });
        c.classList.toggle('is-on', on);
        if (on) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
      });
      if (chips.length && 'IntersectionObserver' in window) {
        const spy = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) setOn(e.target.dataset.stay); }), { rootMargin: '-45% 0px -50% 0px' });
        $$('[data-stay]').forEach((el) => spy.observe(el));
      }
      /* sit the chip row just under the theme's sticky header (which can slide away on scroll) */
      const nav = root.querySelector('[data-index]');
      if (nav) {
        const stuck = (el) => /sticky|fixed/.test(getComputedStyle(el).position);
        const hdrs = () => [...document.querySelectorAll('.shopify-section-group-header-group, header')].filter((el) => !root.contains(el) && stuck(el));
        const place = () => {
          let top = 0;
          hdrs().forEach((h) => { const r = h.getBoundingClientRect(); if (r.height && r.top < 4) top = Math.max(top, Math.round(r.bottom)); });
          nav.style.setProperty('--st-top', top + 'px');
        };
        let pk = false;
        addEventListener('scroll', () => { if (!pk) { pk = true; requestAnimationFrame(() => { pk = false; place(); }); } }, { passive: true });
        addEventListener('resize', place);
        place();
      }
      chips.forEach((c) => c.addEventListener('click', (ev) => {
        const t = root.querySelector(c.getAttribute('href'));
        if (!t) return;
        ev.preventDefault();
        const y = t.getBoundingClientRect().top + scrollY - (nav ? nav.offsetHeight + (parseFloat(nav.style.getPropertyValue('--st-top')) || 0) : 0) - 32;
        window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
        history.replaceState(null, '', c.getAttribute('href'));
      }));

      /* parallax inside each photo frame */
      if (!reduce) {
        const frames = $$('[data-par]');
        let tk = false;
        const run = () => {
          tk = false;
          const vh = innerHeight;
          frames.forEach((f) => {
            const r = f.getBoundingClientRect();
            if (r.bottom < 0 || r.top > vh) return;
            const p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
            const img = f.querySelector('img');
            if (img) img.style.setProperty('--py', `${(-p * r.height * .07).toFixed(1)}px`);
          });
        };
        addEventListener('scroll', () => { if (!tk) { tk = true; requestAnimationFrame(run); } }, { passive: true });
        addEventListener('resize', run);
        run();
      }
    };
    const boot = () => document.querySelectorAll('.jttp-st').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('.jttp-st')));
    document.addEventListener('shopify:block:select', (e) => {
      const el = e.target.closest && e.target.closest('.jttp-st');
      if (el) el.querySelectorAll('.st-reveal').forEach((r) => r.classList.add('is-in'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jttp-vendors"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const init = (root) => {
      if (!root || root.dataset.ready) return;
      root.dataset.ready = '1';
      root.classList.add('has-js');
      const $ = (s) => root.querySelector(s);
      const $$ = (s) => [...root.querySelectorAll(s)];
      const cards = $$('[data-card]');
      const grid = $('[data-grid]');

      /* reveal */
      const io = 'IntersectionObserver' in window && !reduce ? new IntersectionObserver((entries) => {
        let n = 0;
        entries.filter((e) => e.isIntersecting).forEach((e) => { e.target.style.setProperty('--rd', n++ % 6); e.target.classList.add('is-in'); io.unobserve(e.target); });
      }, { rootMargin: '0px 0px -6% 0px' }) : null;
      cards.forEach((c) => (io ? io.observe(c) : c.classList.add('is-in')));

      /* chips + glider + FLIP */
      const glider = $('[data-glider]');
      const moveGlider = () => { const on = $('.vd-chip.is-on'); if (glider && on) { glider.style.width = `${on.offsetWidth}px`; glider.style.transform = `translateX(${on.offsetLeft}px)`; } };
      $$('.vd-chip').forEach((chip) => chip.addEventListener('click', () => {
        $$('.vd-chip').forEach((c) => { const on = c === chip; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', String(on)); });
        moveGlider();
        const before = new Map(cards.filter((c) => !c.classList.contains('is-hidden')).map((c) => [c, c.getBoundingClientRect()]));
        const cat = chip.dataset.cat;
        cards.forEach((c) => c.classList.toggle('is-hidden', !!cat && c.dataset.cat !== cat));
        if (root.dataset.layout === 'rail') grid.scrollTo({ left: 0, behavior: reduce ? 'auto' : 'smooth' });
        if (reduce) return;
        cards.forEach((c) => {
          if (c.classList.contains('is-hidden')) return;
          c.classList.add('is-in'); io?.unobserve(c);
          const old = before.get(c), now = c.getBoundingClientRect();
          if (old) {
            const dx = old.left - now.left, dy = old.top - now.top;
            if (Math.abs(dx) > 1 || Math.abs(dy) > 1) c.animate([{ transform: `translate(${dx}px, ${dy}px)` }, { transform: 'none' }], { duration: 550, easing: 'cubic-bezier(.2,.7,.2,1)' });
          } else {
            c.animate([{ opacity: 0, transform: 'translateY(16px) scale(.97)' }, { opacity: 1, transform: 'none' }], { duration: 500, easing: 'cubic-bezier(.2,.7,.2,1)' });
          }
        });
      }));
      moveGlider();
      document.fonts?.ready.then(moveGlider);
      addEventListener('resize', moveGlider, { passive: true });

      /* rail: arrows + drag to scroll */
      if (root.dataset.layout === 'rail') {
        $$('[data-rail]').forEach((b) => b.addEventListener('click', () => grid.scrollBy({ left: grid.clientWidth * 0.8 * +b.dataset.rail, behavior: reduce ? 'auto' : 'smooth' })));
        let down = null;
        grid.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = { x: e.clientX, left: grid.scrollLeft, moved: false }; });
        addEventListener('pointermove', (e) => {
          if (!down) return;
          const dx = e.clientX - down.x;
          if (Math.abs(dx) > 4) { down.moved = true; root.classList.add('is-dragging'); }
          grid.scrollLeft = down.left - dx;
        });
        addEventListener('pointerup', () => { if (down?.moved) grid.addEventListener('click', (ev) => ev.preventDefault(), { capture: true, once: true }); down = null; root.classList.remove('is-dragging'); });
        grid.addEventListener('dragstart', (e) => e.preventDefault());
      }
    };
    const boot = () => document.querySelectorAll('.jttp-vd').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', (e) => init(e.target.querySelector('.jttp-vd')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["photo-mosaic-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('photo-mosaic')) return;

    const FLY = 1500;

    const TEMPLATES = [
      { cols: 3, rows: 2, cells: [[0, 0, 1, 1], [1, 0, 1, 1], [2, 0, 1, 1], [0, 1, 1, 1], [1, 1, 1, 1], [2, 1, 1, 1]] },
      { cols: 4, rows: 2, cells: [[0, 0, 2, 2], [2, 0, 1, 1], [3, 0, 1, 1], [2, 1, 1, 1], [3, 1, 1, 1]] },
      { cols: 4, rows: 2, cells: [[0, 0, 1, 1], [1, 0, 1, 1], [2, 0, 1, 1], [3, 0, 1, 2], [0, 1, 1, 1], [1, 1, 1, 1], [2, 1, 1, 1]] },
      { cols: 4, rows: 2, cells: [[0, 0, 1, 1], [1, 0, 1, 1], [0, 1, 1, 1], [1, 1, 1, 1], [2, 0, 2, 2]] },
      { cols: 2, rows: 2, cells: [[0, 0, 1, 1], [1, 0, 1, 1], [0, 1, 1, 1], [1, 1, 1, 1]] },
    ];

    const grid = (count, maxCols) => {
      const cols = Math.min(count, maxCols);
      const rows = Math.ceil(count / cols);
      const cells = [];
      for (let i = 0; i < count; i++) cells.push([i % cols, Math.floor(i / cols), 1, 1]);
      return { cols, rows, cells };
    };

    const rand = (range) => (Math.random() - 0.5) * range;
    const mod = (value, size) => ((value % size) + size) % size;
    const easeOut = (t) => 1 - Math.pow(1 - t, 4);
    const rad = (deg) => (deg * Math.PI) / 180;

    class PhotoMosaic extends HTMLElement {
      connectedCallback() {
        this.stage = this.querySelector('.photo-mosaic__stage');
        this.toggle = this.querySelector('.photo-mosaic__toggle');
        const tiles = [...this.querySelectorAll('.photo-mosaic__source > .photo-mosaic__tile')];
        if (!tiles.length) return;

        this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.tilt = this.reduced ? 0 : Number(this.dataset.tilt || 20);
        this.speed = Number(this.dataset.speed || 4) * (this.reduced ? 0.4 : 1);
        this.paused = false;
        this.visible = false;
        this.clock = 0;
        this.offset = null;
        this.last = null;
        this.raf = null;

        this.wall = document.createElement('div');
        this.wall.className = 'photo-mosaic__wall';
        this.wall.setAttribute('aria-hidden', 'true');
        this.stage.insertBefore(this.wall, this.toggle);

        this.groups = [];
        this.base = this.planGroups(tiles.length, this.dataset.perScene || 'auto').map((plan) => {
          const el = document.createElement('div');
          el.className = 'photo-mosaic__group';
          plan.cells.forEach(([c, r, w, h]) => {
            const tile = tiles.shift();
            Object.assign(tile.style, {
              left: `${(c / plan.cols) * 100}%`,
              top: `${(r / plan.rows) * 100}%`,
              width: `${(w / plan.cols) * 100}%`,
              height: `${(h / plan.rows) * 100}%`,
            });
            el.append(tile);
          });
          this.addGroup(el, plan);
          return { el, plan };
        });

        this.frame = this.frame.bind(this);
        this.layout();
        this.toggle.addEventListener('click', () => this.setPaused(!this.paused));
        this.onVisibility = () => this.sync();
        document.addEventListener('visibilitychange', this.onVisibility);
        this.intersection = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.sync();
        });
        this.intersection.observe(this.stage);
        this.resize = new ResizeObserver(() => this.layout());
        this.resize.observe(this.stage);
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.raf);
        this.raf = null;
        this.intersection?.disconnect();
        this.resize?.disconnect();
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      planGroups(total, perScene) {
        const plans = [];
        let remaining = total;
        let step = 0;
        while (remaining > 0) {
          let plan;
          if (perScene !== 'auto') {
            const size = Number(perScene);
            plan = grid(Math.min(size, remaining), size === 4 ? 2 : size / 2);
          } else if (remaining <= 3) {
            plan = grid(remaining, 3);
          } else {
            const fits = (t) => remaining - t.cells.length === 0 || remaining - t.cells.length >= 3;
            plan = TEMPLATES[step % TEMPLATES.length];
            if (!fits(plan)) {
              plan = [...TEMPLATES].sort((a, b) => b.cells.length - a.cells.length).find(fits) || grid(remaining, 4);
            }
          }
          plans.push(plan);
          remaining -= plan.cells.length;
          step++;
        }
        return plans;
      }

      addGroup(el, plan) {
        this.wall.append(el);
        const tiles = [...el.children].map((tileEl, i) => {
          const [c, r, w, h] = plan.cells[i];
          return { el: tileEl, c, r, w, h, jitter: Math.random(), start: null, done: false, from: null };
        });
        this.groups.push({ el, plan, tiles, x0: 0, width: 0, height: 0 });
      }

      screenToWall(screenX, angle) {
        const a = rad(angle);
        const denom = this.perspective * Math.cos(a) - screenX * Math.sin(a);
        if (denom <= 0) return screenX > 0 ? Infinity : -Infinity;
        return (screenX * (this.perspective + this.depth)) / denom;
      }

      layout() {
        const width = this.stage.clientWidth;
        const height = this.stage.clientHeight;
        if (!width || !height) return;
        const narrow = width < 750;

        this.width = width;
        this.height = height;
        this.perspective = Math.max(900, width * 1.3);
        this.depth = width * 0.1;
        this.stage.style.perspective = `${this.perspective}px`;

        const targetHeight = height * (narrow ? 0.5 : 0.64);
        const spacing = width * (narrow ? 0.05 : 0.03);
        const angles = [this.tilt * 0.75, this.tilt * 1.25];
        const leftMost = Math.min(...angles.map((a) => this.screenToWall(-width / 2, a)));
        const rightMost = Math.max(...angles.map((a) => this.screenToWall(width / 2, a)));

        const place = () => {
          let x = 0;
          let widest = 0;
          for (const group of this.groups) {
            const aspect = (group.plan.cols * 4) / (group.plan.rows * 3);
            group.width = Math.min(targetHeight * aspect, width * 2);
            group.height = group.width / aspect;
            group.x0 = x;
            group.el.style.width = `${group.width}px`;
            group.el.style.height = `${group.height}px`;
            for (const tile of group.tiles) {
              tile.cx = ((tile.c + tile.w / 2) / group.plan.cols) * group.width;
            }
            x += group.width + spacing;
            widest = Math.max(widest, group.width);
          }
          return { length: x, widest };
        };

        let { length, widest } = place();
        const buffer = () => -leftMost + widest + width * 0.1;
        let guard = 0;
        while (length < rightMost + buffer() + width * 0.1 && guard < 40) {
          const source = this.base[guard % this.base.length];
          this.addGroup(source.el.cloneNode(true), source.plan);
          ({ length, widest } = place());
          guard++;
        }

        this.length = length;
        this.buffer = buffer();
        if (this.offset === null) this.offset = -(this.screenToWall(width * 0.3, this.tilt) - width * 0.06);
        this.render();
      }

      setPaused(paused) {
        this.paused = paused;
        this.toggleAttribute('data-paused', paused);
        this.toggle.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        this.sync();
      }

      sync() {
        const active = this.visible && !this.paused && !document.hidden;
        if (active && this.raf === null) {
          this.last = null;
          this.raf = requestAnimationFrame(this.frame);
        } else if (!active && this.raf !== null) {
          cancelAnimationFrame(this.raf);
          this.raf = null;
        }
      }

      frame(now) {
        const dt = this.last === null ? 0 : Math.min(now - this.last, 50);
        this.last = now;
        this.clock += dt;
        this.offset += (this.speed * 0.012 * this.width * dt) / 1000;
        this.render();
        this.raf = requestAnimationFrame(this.frame);
      }

      render() {
        if (!this.width) return;
        const t = this.clock;
        const sway = this.reduced ? 0 : 1;
        const angle = this.tilt * (1 + 0.25 * Math.sin(t * 0.00021) * sway);
        const pitch = this.tilt * 0.15 + 1.5 * Math.sin(t * 0.00013) * sway;
        const lift = this.height * 0.015 * Math.sin(t * 0.00017) * sway;
        this.wall.style.transform = `translate3d(0, ${lift}px, ${-this.depth}px) rotateY(${angle}deg) rotateX(${pitch}deg)`;

        const flyLine = this.screenToWall(this.width * 0.3, angle);
        const leftEdge = this.screenToWall(-this.width / 2, angle);
        const firstPaint = !this.primed;
        this.primed = true;

        for (const group of this.groups) {
          const gx = mod(group.x0 - this.offset + this.buffer, this.length) - this.buffer;
          group.el.style.transform = `translate3d(${gx}px, ${-group.height / 2}px, 0)`;
          const offscreen = gx + group.width < leftEdge - this.width * 0.1;
          group.el.style.visibility = offscreen ? 'hidden' : 'visible';

          for (const tile of group.tiles) {
            const trigger = flyLine + (tile.jitter - 0.5) * this.width * 0.12 - tile.r * this.width * 0.03;
            const p = gx + tile.cx;

            if (p > trigger) {
              if (tile.start !== null) {
                tile.start = null;
                tile.done = false;
                tile.el.style.opacity = 0;
              }
              continue;
            }

            if (tile.start === null) {
              tile.start = firstPaint ? -Infinity : t;
              tile.from = this.reduced
                ? { x: 0, y: 0, z: 0, rx: 0, ry: 0, rz: 0 }
                : {
                    x: rand(this.width * 0.5),
                    y: rand(this.height * 0.7) - this.height * 0.1,
                    z: 600 + Math.random() * 500,
                    rx: rand(70),
                    ry: rand(70) - 15,
                    rz: rand(40),
                  };
            }

            if (tile.done) continue;
            const f = Math.min((t - tile.start) / FLY, 1);
            if (f >= 1) {
              tile.el.style.transform = 'none';
              tile.el.style.opacity = 1;
              tile.done = true;
              continue;
            }
            const k = 1 - easeOut(f);
            const from = tile.from;
            tile.el.style.opacity = Math.min(f * 3, 1);
            tile.el.style.transform = `translate3d(${from.x * k}px, ${from.y * k}px, ${from.z * k}px) rotateX(${from.rx * k}deg) rotateY(${from.ry * k}deg) rotateZ(${from.rz * k}deg)`;
          }
        }
      }
    }

    customElements.define('photo-mosaic', PhotoMosaic);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shirt-rack"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shirt-rack')) {
    const EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
    const easeInOut = (t) => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);
    const COLS = 6;
    const ROWS = 4;
    const FRAMES = COLS * ROWS;

    class ShirtRack extends HTMLElement {
      connectedCallback() {
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.setupTurns();

        this.dialog = this.querySelector('.sr-modal');
        if (!this.dialog) return;
        this.slides = Array.from(this.dialog.querySelectorAll('.sr-slide'));
        this.index = 0;

        this.querySelectorAll('button.sr-btn').forEach((btn) => {
          btn.addEventListener('click', () => this.open(Number(btn.dataset.index), btn));
        });
        this.dialog.querySelector('[data-close]').addEventListener('click', () => this.close());
        this.dialog.querySelector('[data-prev]').addEventListener('click', () => this.go(-1));
        this.dialog.querySelector('[data-next]').addEventListener('click', () => this.go(1));
        this.dialog.addEventListener('cancel', (e) => {
          e.preventDefault();
          this.close();
        });
        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog || e.target.classList.contains('sr-slides')) this.close();
        });
        this.dialog.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.go(-1);
          if (e.key === 'ArrowRight') this.go(1);
        });

        let startX = null;
        this.dialog.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
        this.dialog.addEventListener('touchend', (e) => {
          if (startX === null) return;
          const dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 50) this.go(dx < 0 ? 1 : -1);
          startX = null;
        });
      }

      /* Sprite turns: progress 0 = side, 1 = front. */
      setupTurns() {
        const duration = parseFloat(getComputedStyle(this).getPropertyValue('--sr-turn-ms')) || 900;
        const items = Array.from(this.querySelectorAll('.sr-item--sprite'));
        const canHover = window.matchMedia('(hover: hover)');
        if (!items.length) return;

        // Load sprite sheets only once the rack is near the viewport.
        const load = () => items.forEach((item) => {
          const sprite = item.querySelector('.sr-sprite');
          if (sprite.dataset.loading) return;
          sprite.dataset.loading = '1';
          const img = new Image();
          img.onload = () => {
            const item = sprite.closest('.sr-item');
            item.style.setProperty('--sr-sprite', `url("${img.src}")`);
            item.classList.add('is-ready');
            sprite.classList.add('is-ready');
          };
          img.src = sprite.dataset.sprite;
        });
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries) => {
            if (entries.some((e) => e.isIntersecting)) {
              io.disconnect();
              load();
            }
          }, { rootMargin: '400px 0px' });
          io.observe(this);
        } else {
          load();
        }
        this.addEventListener('pointerenter', load, { once: true });
        setTimeout(load, 4000);

        items.forEach((item) => {
          const layers = Array.from(item.querySelectorAll('.sr-sprite__frame'));
          const btn = item.querySelector('.sr-btn');
          const state = { p: 0, raf: 0 };
          const turnTo = (target) => {
            cancelAnimationFrame(state.raf);
            const from = state.p;
            const dist = Math.abs(target - from);
            if (!dist) return;
            if (this.reduced) return this.renderSprite(item, layers, (state.p = target));
            const ms = duration * (0.35 + 0.65 * dist);
            const t0 = performance.now();
            const step = (now) => {
              const t = Math.min(1, (now - t0) / ms);
              state.p = from + (target - from) * easeInOut(t);
              this.renderSprite(item, layers, state.p);
              if (t < 1) state.raf = requestAnimationFrame(step);
            };
            state.raf = requestAnimationFrame(step);
          };
          // Only turn where the CSS also opens the slot (hover-capable pointers), so a front view
          // never renders inside a closed, narrow slot.
          item.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse' && canHover.matches) turnTo(1); });
          item.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') turnTo(0); });
          btn.addEventListener('focus', () => { if (btn.matches(':focus-visible')) turnTo(1); });
          btn.addEventListener('blur', () => { if (!item.matches(':hover')) turnTo(0); });
        });
      }

      renderSprite(item, layers, p) {
        const x = p * (FRAMES - 1);
        const k = Math.min(Math.floor(x), FRAMES - 2);
        const f = x - k;
        const place = (el, n) => {
          el.style.backgroundPosition = `${((n % COLS) / (COLS - 1)) * 100}% ${(Math.floor(n / COLS) / (ROWS - 1)) * 100}%`;
        };
        place(layers[0], k);
        place(layers[1], k + 1);
        const shadow = item.querySelector('.sr-shadow__front');
        if (shadow) {
          const n = Math.round(x);
          const pos = `${((n % COLS) / (COLS - 1)) * 100}% ${(Math.floor(n / COLS) / (ROWS - 1)) * 100}%`;
          shadow.style.webkitMaskPosition = pos;
          shadow.style.maskPosition = pos;
        }
        layers[0].style.opacity = 1;
        layers[1].style.opacity = f.toFixed(3);
        item.style.setProperty('--sr-p', p.toFixed(3));
      }

      open(index, trigger) {
        this.trigger = trigger;
        const from = trigger.querySelector('.sr-hang').getBoundingClientRect();

        this.show(index);
        document.documentElement.classList.add('sr-lock');
        this.dialog.classList.remove('is-closing');
        this.dialog.showModal();
        if (this.reduced) return;

        // Fly the garment from its spot on the rail into the lightbox.
        const slide = this.slides[this.index];
        const img = slide.querySelector('.sr-slide__img');
        const to = img && img.getBoundingClientRect();
        if (to && to.height) {
          const scale = from.height / to.height;
          const dx = from.left + from.width / 2 - (to.left + to.width / 2);
          const dy = from.top - to.top;
          img.animate(
            [
              { transform: `translate(${dx}px, ${dy}px) scale(${scale})`, transformOrigin: '50% 0' },
              { transform: 'none', transformOrigin: '50% 0' },
            ],
            { duration: 750, easing: EASE }
          );
        }
        slide.querySelector('.sr-slide__info').animate(
          [{ opacity: 0, transform: 'translateY(14px)' }, { opacity: 1, transform: 'none' }],
          { duration: 500, delay: 280, easing: EASE, fill: 'backwards' }
        );
      }

      close() {
        if (!this.dialog.open || this.dialog.classList.contains('is-closing')) return;
        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          this.dialog.classList.remove('is-closing');
          this.dialog.close();
          document.documentElement.classList.remove('sr-lock');
          if (this.trigger) this.trigger.focus({ preventScroll: true });
        };
        if (this.reduced) return finish();
        this.dialog.classList.add('is-closing');
        const onEnd = (e) => {
          if (e.target !== this.dialog) return;
          this.dialog.removeEventListener('animationend', onEnd);
          finish();
        };
        this.dialog.addEventListener('animationend', onEnd);
        setTimeout(finish, 450); // in case the fade-out never runs
      }

      go(step) {
        const prev = this.slides[this.index];
        this.show(this.index + step);
        const next = this.slides[this.index];
        if (this.reduced || prev === next) return;

        // Outgoing garment turns away while the next one turns in.
        prev.hidden = false;
        prev.style.pointerEvents = 'none';
        prev.animate(
          [
            { opacity: 1, transform: 'none' },
            { opacity: 0, transform: `translateX(${-step * 90}px) rotateY(${step * 55}deg)` },
          ],
          { duration: 450, easing: EASE }
        ).onfinish = () => {
          prev.hidden = prev !== this.slides[this.index];
          prev.style.pointerEvents = '';
        };
        next.animate(
          [
            { opacity: 0, transform: `translateX(${step * 90}px) rotateY(${-step * 55}deg)` },
            { opacity: 1, transform: 'none' },
          ],
          { duration: 650, easing: EASE }
        );
      }

      show(index) {
        const count = this.slides.length;
        this.index = (index + count) % count;
        this.slides.forEach((slide, i) => {
          slide.hidden = i !== this.index;
        });
        // Warm up the current and neighbouring slides.
        [this.index, (this.index + 1) % count, (this.index - 1 + count) % count].forEach((i) => {
          const img = this.slides[i].querySelector('img');
          if (img) img.loading = 'eager';
        });
      }
    }
    customElements.define('shirt-rack', ShirtRack);
  }

  } catch(e) { console.error(e); }
})();
})();
